
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b995516865 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"e","‰":"‰"},]);
Globalize.a1096582399 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"e","‰":"‰"},]);
Globalize.a244970549 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"e","‰":"‰"},]);
Globalize.a1280106940 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","e":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b1848230093 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b526458643 = messageFormatterFn((function(  ) {
  return function(d) { return "Close"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b356290757 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1522836095 = messageFormatterFn((function(  ) {
  return function(d) { return "Dismiss"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b124175421 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b745939259 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1954354588 = messageFormatterFn((function(  ) {
  return function(d) { return "selected"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1532957519 = messageFormatterFn((function(  ) {
  return function(d) { return "Loading"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b536217598 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1653444260 = messageFormatterFn((function(  ) {
  return function(d) { return "Opens in a new window"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2014383018 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b992907357 = messageFormatterFn((function(  ) {
  return function(d) { return "See less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b495576287 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1708519506 = messageFormatterFn((function(  ) {
  return function(d) { return "See less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1888576893 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. Now choose a check out date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a293174836 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. Now choose " + d["1"] + " to save these dates and close the datepicker."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a552048216 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected, current check in date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a675651913 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected, current check out date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1289656991 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", date disabled"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a689774428 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", current month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b588861687 = messageFormatterFn((function(  ) {
  return function(d) { return "Now showing " + d["0"] + " " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1004463501 = messageFormatterFn((function(  ) {
  return function(d) { return "Date picker opened. Select a date from the tables below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b777869919 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the date picker without saving changes. Or, select a date from the tables below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1336375345 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear selected dates."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1226380516 = messageFormatterFn((function(  ) {
  return function(d) { return "Save changes and close the date picker."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a239082933 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " nights";}, one: function() { return number(d["0"]) + " night";}, two: function() { return number(d["0"]) + " nights";}, few: function() { return number(d["0"]) + " nights";}, many: function() { return number(d["0"]) + " nights";}, other: function() { return number(d["0"]) + " nights";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a107826757 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a620656278 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1842196631 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b930943818 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1391330780 = messageFormatterFn((function(  ) {
  return function(d) { return "Search"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b925903342 = messageFormatterFn((function(  ) {
  return function(d) { return "Edit the check in date in the tables below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1244644253 = messageFormatterFn((function(  ) {
  return function(d) { return "Edit the check out date in the tables below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a391400878 = messageFormatterFn((function(  ) {
  return function(d) { return "selected."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1702800193 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. Close the date picker or proceed to change the selected date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a279357191 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"] + " selected. Close the date picker or proceed to change the selected dates."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1178217331 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. " + d["1"] + ". Close the date picker or proceed to change the selected date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1892313941 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"] + " selected. " + d["2"] + ". Close the date picker or proceed to change the selected dates."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1813810162 = messageFormatterFn((function(  ) {
  return function(d) { return "Start date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a708041899 = messageFormatterFn((function(  ) {
  return function(d) { return "End date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1595096410 = messageFormatterFn((function(  ) {
  return function(d) { return "blank"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a693505336 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1054177380 = messageFormatterFn((function(  ) {
  return function(d) { return "Next month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1144780301 = messageFormatterFn((function(  ) {
  return function(d) { return "Skip to " + d["0"] + " button"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b954652661 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " through " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b13863278 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates have been cleared"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1398136987 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "there " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return "are " + number(d["0"]) + " results";}, one: function() { return "is " + number(d["0"]) + " result";}, two: function() { return "are " + number(d["0"]) + " results";}, few: function() { return "are " + number(d["0"]) + " results";}, many: function() { return "are " + number(d["0"]) + " results";}, other: function() { return "are " + number(d["0"]) + " results";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b948834372 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "“" + d["0"] + "” " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " results are";}, one: function() { return number(d["1"]) + " result is";}, two: function() { return number(d["1"]) + " results are";}, few: function() { return number(d["1"]) + " results are";}, many: function() { return number(d["1"]) + " results are";}, other: function() { return number(d["1"]) + " results are";} }) + " available. Use the arrow keys or swipe to navigate the list."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b130726120 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " search open, enter search term."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1289189545 = messageFormatterFn((function(  ) {
  return function(d) { return "You selected " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a907632756 = messageFormatterFn((function(  ) {
  return function(d) { return "The menu is closed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a501279930 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " search open, currently showing " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " suggestions";}, one: function() { return number(d["1"]) + " suggestion";}, two: function() { return number(d["1"]) + " suggestions";}, few: function() { return number(d["1"]) + " suggestions";}, many: function() { return number(d["1"]) + " suggestions";}, other: function() { return number(d["1"]) + " suggestions";} }) + " for " + d["2"] + ". Navigate to list below."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1159565629 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " search open, showing " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " suggestions";}, one: function() { return number(d["1"]) + " suggestion";}, two: function() { return number(d["1"]) + " suggestions";}, few: function() { return number(d["1"]) + " suggestions";}, many: function() { return number(d["1"]) + " suggestions";}, other: function() { return number(d["1"]) + " suggestions";} }) + ". Enter search term or navigate to list below."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1255693017 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " search open, currently selected " + d["1"] + " showing " + plural(d["2"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["2"]) + " suggestions";}, one: function() { return number(d["2"]) + " suggestion";}, two: function() { return number(d["2"]) + " suggestions";}, few: function() { return number(d["2"]) + " suggestions";}, many: function() { return number(d["2"]) + " suggestions";}, other: function() { return number(d["2"]) + " suggestions";} }) + " for " + d["3"] + ". Navigate to list below."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2019815457 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b293062774 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear All"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a516989353 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected Items"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2142729226 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " removed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a536246371 = messageFormatterFn((function(  ) {
  return function(d) { return "All selections removed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1063459538 = messageFormatterFn((function(  ) {
  return function(d) { return "You have entered into input text field. Please search or select from suggested categories below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2097408881 = messageFormatterFn((function(  ) {
  return function(d) { return "Search for “" + d["0"] + "”"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1270912398 = messageFormatterFn((function(  ) {
  return function(d) { return "No results for “" + d["0"] + "”"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1755702940 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2112092275 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1384764893 = messageFormatterFn((function(  ) {
  return function(d) { return "Point of interest"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a516550932 = messageFormatterFn((function(  ) {
  return function(d) { return "Nearby"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b273097719 = messageFormatterFn((function(  ) {
  return function(d) { return "Try “" + d["0"] + "”"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b58587396 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/City"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a33696496 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1834386808 = messageFormatterFn((function(  ) {
  return function(d) { return "Attraction"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1502409703 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a417481689 = messageFormatterFn((function(  ) {
  return function(d) { return "Address"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a245915997 = messageFormatterFn((function(  ) {
  return function(d) { return "Train Station"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2022471316 = messageFormatterFn((function(  ) {
  return function(d) { return "Metro Station"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1719600528 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore nearby places"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1268442233 = messageFormatterFn((function(  ) {
  return function(d) { return "Recent searches"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1345033121 = messageFormatterFn((function(  ) {
  return function(d) { return "People also searched"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b761470666 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore trending destinations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1076529794 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular destinations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a629614782 = messageFormatterFn((function(  ) {
  return function(d) { return "Trending destinations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1877955264 = messageFormatterFn((function(  ) {
  return function(d) { return "Your location"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1743346307 = messageFormatterFn((function(  ) {
  return function(d) { return "Location sharing disabled"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b527020621 = messageFormatterFn((function(  ) {
  return function(d) { return "We are unable to determine your location. Please turn on Location Services on your device so we can determine your location, or type in a destination."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1181406673 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " rooms";}, one: function() { return number(d["0"]) + " room";}, two: function() { return number(d["0"]) + " rooms";}, few: function() { return number(d["0"]) + " rooms";}, many: function() { return number(d["0"]) + " rooms";}, other: function() { return number(d["0"]) + " rooms";} }) + ", " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " travellers";}, one: function() { return number(d["1"]) + " traveller";}, two: function() { return number(d["1"]) + " travellers";}, few: function() { return number(d["1"]) + " travellers";}, many: function() { return number(d["1"]) + " travellers";}, other: function() { return number(d["1"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a330666469 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " travellers";}, one: function() { return number(d["0"]) + " traveller";}, two: function() { return number(d["0"]) + " travellers";}, few: function() { return number(d["0"]) + " travellers";}, many: function() { return number(d["0"]) + " travellers";}, other: function() { return number(d["0"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b776157729 = messageFormatterFn((function(  ) {
  return function(d) { return "The value of the " + d["0"] + " field is now " + d["1"] + ". The value of the " + d["2"] + " field is now " + d["3"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1185420046 = messageFormatterFn((function(  ) {
  return function(d) { return "Swap " + d["0"] + " and " + d["1"] + " fields."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a403336549 = messageFormatterFn((function(  ) {
  return function(d) { return "Show password"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a88994410 = messageFormatterFn((function(  ) {
  return function(d) { return "Hide password"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b759300061 = messageFormatterFn((function(  ) {
  return function(d) { return "Now showing " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a433625490 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " out of " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1389106532 = messageFormatterFn((function(  ) {
  return function(d) { return "Image " + d["0"] + " out of " + d["1"] + ". " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a169567969 = messageFormatterFn((function(  ) {
  return function(d) { return "Show next image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1715772253 = messageFormatterFn((function(  ) {
  return function(d) { return "Show previous image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b417432675 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Show " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " images";}, one: function() { return number(d["0"]) + " image";}, two: function() { return number(d["0"]) + " images";}, few: function() { return "all " + number(d["0"]) + " images";}, many: function() { return "all " + number(d["0"]) + " images";}, other: function() { return "all " + number(d["0"]) + " images";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a158991992 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Show " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " images";}, one: function() { return number(d["0"]) + " image";}, two: function() { return number(d["0"]) + " images";}, few: function() { return "all " + number(d["0"]) + " images";}, many: function() { return "all " + number(d["0"]) + " images";}, other: function() { return "all " + number(d["0"]) + " images";} }) + " for " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b24093387 = messageFormatterFn((function(  ) {
  return function(d) { return "Completed:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2060152669 = messageFormatterFn((function(  ) {
  return function(d) { return "Current:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1504731793 = messageFormatterFn((function(  ) {
  return function(d) { return "Step " + d["0"] + " of " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b350991829 = messageFormatterFn((function(  ) {
  return function(d) { return "Step " + d["0"] + " of " + d["1"] + ":"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b861725460 = messageFormatterFn((function(  ) {
  return function(d) { return "Image " + d["0"] + " of " + d["1"] + ". " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b677466007 = messageFormatterFn((function(  ) {
  return function(d) { return "Next image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b965222171 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a185428393 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", expand to full screen view"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1772490933 = messageFormatterFn((function(  ) {
  return function(d) { return "Item " + d["0"] + ", expand to full screen view"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1478916991 = messageFormatterFn((function(  ) {
  return function(d) { return "Current page"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b452534255 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more breadcrumbs"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b490355371 = messageFormatterFn((function(  ) {
  return function(d) { return "Show less breadcrumbs"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1764065800 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " percent loading"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1009135757 = messageFormatterFn((function(  ) {
  return function(d) { return "Loading"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1830592419 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a405036084 = messageFormatterFn((function(  ) {
  return function(d) { return "An error occurred."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b961275880 = messageFormatterFn((function(  ) {
  return function(d) { return "Try watching this video on www.youtube.com, or enable Javascript if it is disabled in your browser."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1717553952 = messageFormatterFn((function(  ) {
  return function(d) { return "Play video"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a953780048 = messageFormatterFn((function(  ) {
  return function(d) { return "Pause video"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1638350424 = messageFormatterFn((function(  ) {
  return function(d) { return "Video loading"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b911573026 = messageFormatterFn((function(  ) {
  return function(d) { return "Photosphere"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2041787384 = messageFormatterFn((function(  ) {
  return function(d) { return "This is a 360 degree image. Use control and arrow keys or command and arrow keys to move around it"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1911527659 = messageFormatterFn((function(  ) {
  return function(d) { return "Currently displaying: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a148143370 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving left. Position: " + d["0"] + " degrees"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1442691663 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving right. Position: " + d["0"] + " degrees"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b982808418 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b71153947 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving down"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2066293398 = messageFormatterFn((function(  ) {
  return function(d) { return "You are at the top"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1704706252 = messageFormatterFn((function(  ) {
  return function(d) { return "You are at the bottom"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1308097696 = messageFormatterFn((function(  ) {
  return function(d) { return "Select all rows"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b398419137 = messageFormatterFn((function(  ) {
  return function(d) { return "Deselect all rows"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a264617679 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort column by descending order"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1437506441 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort column by ascending order"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1184205177 = messageFormatterFn((function(  ) {
  return function(d) { return "Column is now in descending order"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a925081409 = messageFormatterFn((function(  ) {
  return function(d) { return "Column is now in ascending order"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1415930087 = messageFormatterFn((function(  ) {
  return function(d) { return "Expand row " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1175846906 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Showing " + d["0"] + " of " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " items";}, one: function() { return number(d["1"]) + " item";}, two: function() { return number(d["1"]) + " items";}, few: function() { return number(d["1"]) + " items";}, many: function() { return number(d["1"]) + " items";}, other: function() { return number(d["1"]) + " items";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1384932426 = messageFormatterFn((function(  ) {
  return function(d) { return "your current months are " + d["0"] + ", " + d["1"] + " and " + d["2"] + ", " + d["3"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1516824994 = messageFormatterFn((function(  ) {
  return function(d) { return "your current month is " + d["0"] + ", " + d["1"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1488979981 = messageFormatterFn((function(  ) {
  return function(d) { return "your current months are between " + d["0"] + ", " + d["1"] + " and " + d["2"] + ", " + d["3"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b827910542 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in date cleared."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b303642203 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out date cleared."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1585140634 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates cleared."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1427161781 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1185327211 = messageFormatterFn((function(  ) {
  return function(d) { return "Submit"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1340231608 = messageFormatterFn((function(  ) {
  return function(d) { return "Next"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1795430136 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a361434142 = messageFormatterFn((function(  ) {
  return function(d) { return "Skip to Submit button"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a105250513 = messageFormatterFn((function(  ) {
  return function(d) { return "Skip to " + d["0"] + " button"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b97950338 = messageFormatterFn((function(  ) {
  return function(d) { return "Next month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1388173762 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1513397511 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is selected as your check-in date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a585846836 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is selected as your check-out date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b306468829 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is not a valid check-in date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b489601406 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is not a valid check-out date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a217737839 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is unavailable."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2038241376 = messageFormatterFn((function(  ) {
  return function(d) { return "Today"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1682346626 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected start date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1693900293 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected end date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a665174810 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b893009418 = messageFormatterFn((function(  ) {
  return function(d) { return "Start date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a502982191 = messageFormatterFn((function(  ) {
  return function(d) { return "End date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1018291088 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the date selector without saving changes. Or, select a date from the tables below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1160352577 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " out of " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2091370454 = messageFormatterFn((function(  ) {
  return function(d) { return "Press escape to dismiss."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b687079617 = messageFormatterFn((function(  ) {
  return function(d) { return "Press escape to collapse."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b793831666 = messageFormatterFn((function(  ) {
  return function(d) { return "Please enter a number less than " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1175323123 = messageFormatterFn((function(  ) {
  return function(d) { return "Please enter a number greater than " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1133105920 = messageFormatterFn((function(  ) {
  return function(d) { return "Please enter a number between " + d["0"] + " and " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a677964145 = messageFormatterFn((function(  ) {
  return function(d) { return "Required"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1687387229 = messageFormatterFn((function(  ) {
  return function(d) { return "Delete " + d["0"] + " from recent searches"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1180968030 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " was deleted from recent searches"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a595698168 = messageFormatterFn((function(  ) {
  return function(d) { return "Transit"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2084961766 = messageFormatterFn((function(  ) {
  return function(d) { return "Property"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a387177522 = messageFormatterFn((function(  ) {
  return function(d) { return "Star rating"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1206070824 = messageFormatterFn((function(  ) {
  return function(d) { return "5 star"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b536739511 = messageFormatterFn((function(  ) {
  return function(d) { return "4 star & up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2015417450 = messageFormatterFn((function(  ) {
  return function(d) { return "3 star & up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a272607115 = messageFormatterFn((function(  ) {
  return function(d) { return "2 star & up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a711846736 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove all filters"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1635344588 = messageFormatterFn((function(  ) {
  return function(d) { return "All filters have been removed"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a195080232 = messageFormatterFn((function(  ) {
  return function(d) { return "Trip length"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a185636513 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight class"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1621551210 = messageFormatterFn((function(  ) {
  return function(d) { return "This is the price of the stay and flight if bought separately on our site."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1271580771 = messageFormatterFn((function(  ) {
  return function(d) { return "This is the price of the stay, flight and car if bought separately on our site."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1621496433 = messageFormatterFn((function(  ) {
  return function(d) { return "This is the price of the stay and car if bought separately on our site."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1804951681 = messageFormatterFn((function(  ) {
  return function(d) { return "All deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b723691212 = messageFormatterFn((function(  ) {
  return function(d) { return "Roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1348712348 = messageFormatterFn((function(  ) {
  return function(d) { return "One way"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1740331185 = messageFormatterFn((function(  ) {
  return function(d) { return "just found"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1682443701 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "found " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1304560085 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "found " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " days";}, one: function() { return number(d["0"]) + " day";}, two: function() { return number(d["0"]) + " days";}, few: function() { return number(d["0"]) + " days";}, many: function() { return number(d["0"]) + " days";}, other: function() { return number(d["0"]) + " days";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b596889030 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " with " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b517417694 = messageFormatterFn((function(  ) {
  return function(d) { return "Find deals from " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b91515072 = messageFormatterFn((function(  ) {
  return function(d) { return "Origin"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1002978486 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1110281095 = messageFormatterFn((function(  ) {
  return function(d) { return "Travel dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b475904055 = messageFormatterFn((function(  ) {
  return function(d) { return "Flights from*"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312012918 = messageFormatterFn((function(  ) {
  return function(d) { return "January"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312013879 = messageFormatterFn((function(  ) {
  return function(d) { return "February"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312014840 = messageFormatterFn((function(  ) {
  return function(d) { return "March"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312015801 = messageFormatterFn((function(  ) {
  return function(d) { return "April"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312016762 = messageFormatterFn((function(  ) {
  return function(d) { return "May"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312017723 = messageFormatterFn((function(  ) {
  return function(d) { return "June"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312018684 = messageFormatterFn((function(  ) {
  return function(d) { return "July"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312019645 = messageFormatterFn((function(  ) {
  return function(d) { return "August"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1312020606 = messageFormatterFn((function(  ) {
  return function(d) { return "September"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2017706512 = messageFormatterFn((function(  ) {
  return function(d) { return "October"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2017707473 = messageFormatterFn((function(  ) {
  return function(d) { return "November"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2017708434 = messageFormatterFn((function(  ) {
  return function(d) { return "December"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1309763371 = messageFormatterFn((function(  ) {
  return function(d) { return "*Prices include taxes and fees"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1851301964 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " on " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1430280416 = messageFormatterFn((function(  ) {
  return function(d) { return "next dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1498980384 = messageFormatterFn((function(  ) {
  return function(d) { return "previous dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b62231371 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b552912042 = messageFormatterFn((function(  ) {
  return function(d) { return "Select " + d["0"] + " flight, departing " + d["1"] + " from " + d["2"] + " to " + d["3"] + ", returning " + d["4"] + ", priced at " + d["5"] + " " + d["6"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1612855580 = messageFormatterFn((function(  ) {
  return function(d) { return "Select " + d["0"] + " flight, departing " + d["1"] + " from " + d["2"] + " to " + d["3"] + ", priced at " + d["4"] + " " + d["5"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b440049660 = messageFormatterFn((function(  ) {
  return function(d) { return "A verified traveller"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b240141567 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"] + " &" + "#" + "183; " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1999288506 = messageFormatterFn((function(  ) {
  return function(d) { return "view more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1961467390 = messageFormatterFn((function(  ) {
  return function(d) { return "view less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a898195047 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Unlock Member Prices!" + d["1"] + " You can save an average of " + d["2"] + "% on thousands of hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a674595339 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Unlock Member Prices!" + d["1"] + " You can save " + d["2"] + "% or more on thousands of hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1619543630 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Get 1 reward night*" + d["1"] + " for every 10 nights you stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b678700223 = messageFormatterFn((function(  ) {
  return function(d) { return "Find out more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1869714071 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Rack up rewards" + d["1"] + " in over 1 million properties worldwide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b474515901 = messageFormatterFn((function(  ) {
  return function(d) { return "JOIN NOW"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b934780735 = messageFormatterFn((function(  ) {
  return function(d) { return "SIGN IN"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1875995496 = messageFormatterFn((function(  ) {
  return function(d) { return "*See further details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a129009554 = messageFormatterFn((function(  ) {
  return function(d) { return "*See terms and conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1432376195 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "Unlock Secret Prices!" + d["1"] + " You could get 10% off"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1001067553 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a326436880 = messageFormatterFn((function(  ) {
  return function(d) { return "All hotels with " + d["0"] + " star rating"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b17328853 = messageFormatterFn((function(  ) {
  return function(d) { return "Check rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1468730727 = messageFormatterFn((function(  ) {
  return function(d) { return "Check availability"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2137263096 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a101321292 = messageFormatterFn((function(  ) {
  return function(d) { return "Find deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1950241488 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b228580895 = messageFormatterFn((function(  ) {
  return function(d) { return "Find lodging"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1648102692 = messageFormatterFn((function(  ) {
  return function(d) { return "Find properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1651847451 = messageFormatterFn((function(  ) {
  return function(d) { return "Find places to stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1612128129 = messageFormatterFn((function(  ) {
  return function(d) { return "Go"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a429303533 = messageFormatterFn((function(  ) {
  return function(d) { return "Get deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b372726609 = messageFormatterFn((function(  ) {
  return function(d) { return "Get hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1429740098 = messageFormatterFn((function(  ) {
  return function(d) { return "Get lodging"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b320000733 = messageFormatterFn((function(  ) {
  return function(d) { return "Get properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b276285030 = messageFormatterFn((function(  ) {
  return function(d) { return "Get places to stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1163943169 = messageFormatterFn((function(  ) {
  return function(d) { return "Show me deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1776233181 = messageFormatterFn((function(  ) {
  return function(d) { return "Show me hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b671983148 = messageFormatterFn((function(  ) {
  return function(d) { return "Show me lodging"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b723981231 = messageFormatterFn((function(  ) {
  return function(d) { return "Show me properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1879355848 = messageFormatterFn((function(  ) {
  return function(d) { return "Show me places to stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b121889468 = messageFormatterFn((function(  ) {
  return function(d) { return "Inspire me"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b520140263 = messageFormatterFn((function(  ) {
  return function(d) { return "Surprise me"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a321945545 = messageFormatterFn((function(  ) {
  return function(d) { return "Delight me"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1359456301 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodations and flight packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1359511078 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodations and car packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1359451496 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight and car packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b806466900 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodations, flight, and car packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a619730627 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose two or more items and save on your trip:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1657420323 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose one or more items to build your trip:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1806837978 = messageFormatterFn((function(  ) {
  return function(d) { return "Bundle and save"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b815584518 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2040481635 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1103370006 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2008907358 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight added"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a570006215 = messageFormatterFn((function(  ) {
  return function(d) { return "Stay added"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b367105414 = messageFormatterFn((function(  ) {
  return function(d) { return "Car added"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1004347434 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with cash"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1633319814 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with points"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1982134219 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1502917876 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a655539858 = messageFormatterFn((function(  ) {
  return function(d) { return "Add accommodation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a32442456 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel added"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b814935562 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodation added"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b547711066 = messageFormatterFn((function(  ) {
  return function(d) { return "Search stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1073724681 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by destination, accommodations, or landmark"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1054413905 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by city or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2117885527 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by city, airport, or address"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1222412276 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by city"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1977590726 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you going?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1226983394 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you leaving from?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a17661228 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you going to?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2015911078 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you picking up your car?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1013745204 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you dropping off your car?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2118529651 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select one or more items"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1066804619 = messageFormatterFn((function(  ) {
  return function(d) { return "To start building your trip, choose one or more items"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1815686386 = messageFormatterFn((function(  ) {
  return function(d) { return "For expert cruise advice, call " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b402036970 = messageFormatterFn((function(  ) {
  return function(d) { return "Find accommodation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a248683993 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b222317002 = messageFormatterFn((function(  ) {
  return function(d) { return "Find and compare flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1749845060 = messageFormatterFn((function(  ) {
  return function(d) { return "Save with holiday packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b840638090 = messageFormatterFn((function(  ) {
  return function(d) { return "Find and compare car hire deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b467511612 = messageFormatterFn((function(  ) {
  return function(d) { return "Find things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1197847701 = messageFormatterFn((function(  ) {
  return function(d) { return "Search accommodation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a877354113 = messageFormatterFn((function(  ) {
  return function(d) { return "Search flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1479911257 = messageFormatterFn((function(  ) {
  return function(d) { return "Build a holiday package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1822217995 = messageFormatterFn((function(  ) {
  return function(d) { return "Search car hire deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2119108761 = messageFormatterFn((function(  ) {
  return function(d) { return "Search things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b171784113 = messageFormatterFn((function(  ) {
  return function(d) { return "Search and compare flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b978602677 = messageFormatterFn((function(  ) {
  return function(d) { return "Save on packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b199512579 = messageFormatterFn((function(  ) {
  return function(d) { return "Rent a ride"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a313829974 = messageFormatterFn((function(  ) {
  return function(d) { return "Search stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b86382370 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1915159713 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Staycations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a918595240 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Vacation Rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1241966462 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b850113732 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1956193548 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2077635541 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1184703511 = messageFormatterFn((function(  ) {
  return function(d) { return "Use MileagePlus miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1536657241 = messageFormatterFn((function(  ) {
  return function(d) { return "Use MileagePlus miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1172412537 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b515647465 = messageFormatterFn((function(  ) {
  return function(d) { return "Pay with miles"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1382626000 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1431166481 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Staycations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b786785546 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Vacation Rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1000077840 = messageFormatterFn((function(  ) {
  return function(d) { return "Search Cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b995696451 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1122613660 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1821233109 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight + Hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1917833518 = messageFormatterFn((function(  ) {
  return function(d) { return "Search flight + hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b594762517 = messageFormatterFn((function(  ) {
  return function(d) { return "Things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1345625183 = messageFormatterFn((function(  ) {
  return function(d) { return "Beach Holidays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1284792085 = messageFormatterFn((function(  ) {
  return function(d) { return "Above average prices."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b526031143 = messageFormatterFn((function(  ) {
  return function(d) { return "Below average prices."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a220582833 = messageFormatterFn((function(  ) {
  return function(d) { return "Higher prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1176830069 = messageFormatterFn((function(  ) {
  return function(d) { return "Lower prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b179769261 = messageFormatterFn((function(  ) {
  return function(d) { return "Price trend information from the first " + d["0"] + " properties on this page based on nightly stay rates for 2 adults found in the last 24 hours on our site."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b331753695 = messageFormatterFn((function(  ) {
  return function(d) { return "Compact"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1654569092 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b720545880 = messageFormatterFn((function(  ) {
  return function(d) { return "Fullsize"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1124991067 = messageFormatterFn((function(  ) {
  return function(d) { return "Luxury"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1897958599 = messageFormatterFn((function(  ) {
  return function(d) { return "Midsize"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1908038954 = messageFormatterFn((function(  ) {
  return function(d) { return "Minivan"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b188610418 = messageFormatterFn((function(  ) {
  return function(d) { return "Other"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1119193260 = messageFormatterFn((function(  ) {
  return function(d) { return "Pickup"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b8426155 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a97439379 = messageFormatterFn((function(  ) {
  return function(d) { return "Sports Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2120868843 = messageFormatterFn((function(  ) {
  return function(d) { return "Standard"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1346180206 = messageFormatterFn((function(  ) {
  return function(d) { return "SUV"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1344013151 = messageFormatterFn((function(  ) {
  return function(d) { return "Van"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a894345074 = messageFormatterFn((function(  ) {
  return function(d) { return "Car Type"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a861680959 = messageFormatterFn((function(  ) {
  return function(d) { return "Have a trip in mind?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a989855399 = messageFormatterFn((function(  ) {
  return function(d) { return "Search all flights, hotels, packages and more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1203618266 = messageFormatterFn((function(  ) {
  return function(d) { return "Search flights, hotels and more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b930665771 = messageFormatterFn((function(  ) {
  return function(d) { return "Include package rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1022910507 = messageFormatterFn((function(  ) {
  return function(d) { return "You receive special insider prices on properties when they're booked in combination with a flight, car, train or cruise for your traveller."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1261092796 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " / 5"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1613739306 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Verified Review"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1883891441 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " from " + d["1"] + " stayed at " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a373251290 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " stayed at " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1834828315 = messageFormatterFn((function(  ) {
  return function(d) { return "A verified traveller from " + d["0"] + " stayed at " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b905423794 = messageFormatterFn((function(  ) {
  return function(d) { return "A verified traveller stayed at " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a876103357 = messageFormatterFn((function(  ) {
  return function(d) { return "Open " + d["0"] + " guest reviews"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1123199838 = messageFormatterFn((function(  ) {
  return function(d) { return "Posted less than an hour ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1538932560 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Posted " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1653927922 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Posted " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " days";}, one: function() { return number(d["0"]) + " day";}, two: function() { return number(d["0"]) + " days";}, few: function() { return number(d["0"]) + " days";}, many: function() { return number(d["0"]) + " days";}, other: function() { return number(d["0"]) + " days";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b251847328 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Posted " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " weeks";}, one: function() { return number(d["0"]) + " week";}, two: function() { return number(d["0"]) + " weeks";}, few: function() { return number(d["0"]) + " weeks";}, many: function() { return number(d["0"]) + " weeks";}, other: function() { return number(d["0"]) + " weeks";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b751028586 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Posted " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " months";}, one: function() { return number(d["0"]) + " month";}, two: function() { return number(d["0"]) + " months";}, few: function() { return number(d["0"]) + " months";}, many: function() { return number(d["0"]) + " months";}, other: function() { return number(d["0"]) + " months";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a917259356 = messageFormatterFn((function(  ) {
  return function(d) { return "Posted 1 year ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a840859352 = messageFormatterFn((function(  ) {
  return function(d) { return "Posted over a year ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1476121220 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " out of 5"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a730119740 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/5"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1645278603 = messageFormatterFn((function(  ) {
  return function(d) { return "Excellent"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1077007412 = messageFormatterFn((function(  ) {
  return function(d) { return "Good"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1301949643 = messageFormatterFn((function(  ) {
  return function(d) { return "Okay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1334683225 = messageFormatterFn((function(  ) {
  return function(d) { return "Poor"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1594955718 = messageFormatterFn((function(  ) {
  return function(d) { return "Terrible"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1098275485 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " verified reviews"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1706025126 = messageFormatterFn((function(  ) {
  return function(d) { return "Guest reviews"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a13232660 = messageFormatterFn((function(  ) {
  return function(d) { return "Close, go back to hotel details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1754724769 = messageFormatterFn((function(  ) {
  return function(d) { return "Best rated stations in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1694048339 = messageFormatterFn((function(  ) {
  return function(d) { return "Average pickup time: " + d["0"] + " minutes."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1570508801 = messageFormatterFn((function(  ) {
  return function(d) { return "out of 10"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a412770970 = messageFormatterFn((function(  ) {
  return function(d) { return "(" + d["0"] + " reviews)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1563843031 = messageFormatterFn((function(  ) {
  return function(d) { return "Friendliness"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1511220138 = messageFormatterFn((function(  ) {
  return function(d) { return "Cleanliness"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a970815459 = messageFormatterFn((function(  ) {
  return function(d) { return "Pickup time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b183101210 = messageFormatterFn((function(  ) {
  return function(d) { return "Overall value"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1107105428 = messageFormatterFn((function(  ) {
  return function(d) { return "Reviewed on " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2075176454 = messageFormatterFn((function(  ) {
  return function(d) { return "Address:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1877045945 = messageFormatterFn((function(  ) {
  return function(d) { return "Longitude:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1491617642 = messageFormatterFn((function(  ) {
  return function(d) { return "Latitude:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b58510409 = messageFormatterFn((function(  ) {
  return function(d) { return "Time zone:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1216140688 = messageFormatterFn((function(  ) {
  return function(d) { return "IATA code:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1167568143 = messageFormatterFn((function(  ) {
  return function(d) { return "Name: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a106799929 = messageFormatterFn((function(  ) {
  return function(d) { return "Location: " + d["0"] + ", " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a865308657 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport codes:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1024627081 = messageFormatterFn((function(  ) {
  return function(d) { return "IATA: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1025921548 = messageFormatterFn((function(  ) {
  return function(d) { return "ICAO: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2006317129 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Wikipedia information"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1318310603 = messageFormatterFn((function(  ) {
  return function(d) { return "Official " + d["0"] + " website"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1917366492 = messageFormatterFn((function(  ) {
  return function(d) { return "Precip: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1630199648 = messageFormatterFn((function(  ) {
  return function(d) { return "HIGH: " + d["0"] + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1475319660 = messageFormatterFn((function(  ) {
  return function(d) { return "LOW: " + d["0"] + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1623215937 = messageFormatterFn((function(  ) {
  return function(d) { return "Longitude: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2020171312 = messageFormatterFn((function(  ) {
  return function(d) { return "Latitude: " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a712309554 = messageFormatterFn((function(  ) {
  return function(d) { return "Delay outlook"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a260041527 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimal disruption"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2143274301 = messageFormatterFn((function(  ) {
  return function(d) { return "Moderate disruption"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b756472524 = messageFormatterFn((function(  ) {
  return function(d) { return "Severe disruption"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1295977026 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport information"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1057515785 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport Map Image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a387801046 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport map photo gallery"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2027948892 = messageFormatterFn((function(  ) {
  return function(d) { return "Close airport photo gallery"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b111118382 = messageFormatterFn((function(  ) {
  return function(d) { return "Close airport map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1119933256 = messageFormatterFn((function(  ) {
  return function(d) { return "airport static map image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a590930158 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport address map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b328300627 = messageFormatterFn((function(  ) {
  return function(d) { return "Current conditions at " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2030170259 = messageFormatterFn((function(  ) {
  return function(d) { return "Get best deals in " + d["0"] + ", " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1182089938 = messageFormatterFn((function(  ) {
  return function(d) { return "Get best deals close to " + d["0"] + ", " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b659502324 = messageFormatterFn((function(  ) {
  return function(d) { return "This weekend"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2131019635 = messageFormatterFn((function(  ) {
  return function(d) { return "Cheapest weekend"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1494347164 = messageFormatterFn((function(  ) {
  return function(d) { return "Tonight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1742979469 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for tonight, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1871133710 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for tonight, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1967703489 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for next weekend, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2023581437 = messageFormatterFn((function(  ) {
  return function(d) { return "Best deal"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1742838490 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for next weekend, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1908780320 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for tomorrow night, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b667312553 = messageFormatterFn((function(  ) {
  return function(d) { return "Next weekend"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b109652298 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for this weekend, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b713268411 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for tomorrow night, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2041665206 = messageFormatterFn((function(  ) {
  return function(d) { return "Get price"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a874983094 = messageFormatterFn((function(  ) {
  return function(d) { return "Tomorrow night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a985313563 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for this weekend, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1740397803 = messageFormatterFn((function(  ) {
  return function(d) { return "In two weeks"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1479143238 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for the weekend in two weeks, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1348420949 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for the weekend in two weeks, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1571710674 = messageFormatterFn((function(  ) {
  return function(d) { return "In one month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a436288097 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for the weekend in one month, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1554384380 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for the weekend in one month, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1579652451 = messageFormatterFn((function(  ) {
  return function(d) { return "In two months"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1612235028 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices close to " + d["0"] + " for the weekend in two months, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b23935609 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices in " + d["0"] + " for the weekend in two months, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b575442053 = messageFormatterFn((function(  ) {
  return function(d) { return "Apply"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b419824815 = messageFormatterFn((function(  ) {
  return function(d) { return "Results are loading"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a620974205 = messageFormatterFn((function(  ) {
  return function(d) { return "Results updated"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1459539547 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a394961406 = messageFormatterFn((function(  ) {
  return function(d) { return "Your flight was cancelled and the airline has rebooked you on a different flight. It has come to our attention that you may miss your connecting flight because the layover doesn't allow enough time for you to reach the departure gate."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a394962367 = messageFormatterFn((function(  ) {
  return function(d) { return "If you don't intend to travel, we can cancel your entire trip for you. If you cancel, we'll cancel all of the flights associated with your itinerary. We'll also give you an airline credit in the amount of the original ticket price to use for a future flight with the same airline. You will not be charged a cancellation fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a394963328 = messageFormatterFn((function(  ) {
  return function(d) { return "If you don't want to cancel your trip, we'll leave the adjusted itinerary as it is."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a394964289 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want to cancel your trip?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1866577744 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my trip, I confirm that I want to cancel all of the flights associated with my itinerary."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1970513445 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, cancel my trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1942013840 = messageFormatterFn((function(  ) {
  return function(d) { return "No, don’t cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1519622168 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1252034207 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send a confirmation email to " + d["0"] + " within the next 14 days. We may not be able to respond before your departure date. However, rest assured that your cancellation will be processed. No further action is required on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1252033246 = messageFormatterFn((function(  ) {
  return function(d) { return "You'll receive an airline credit in the amount of the original ticket price to use for a future flight with the same airline."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1252032285 = messageFormatterFn((function(  ) {
  return function(d) { return "Due to the unprecedented volume of travel disruptions, your airline credit may take up to 30 days to process. You will receive another email when your airline credit is available. This email will contain the amount of the airline credit, the expiration date, and how to use it for a future flight."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2036149812 = messageFormatterFn((function(  ) {
  return function(d) { return "We didn’t cancel your trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b722617299 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you want to keep your trip."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b722616338 = messageFormatterFn((function(  ) {
  return function(d) { return "Many flights have been cancelled due to COVID-19. As a result, there are limited options for rebooking your flight. The new flight was the best option the airline was able to offer."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b722615377 = messageFormatterFn((function(  ) {
  return function(d) { return "Please check your itinerary for the most recent information about your trip."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1484206427 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, get a " + d["0"] + "% " + d["1"] + " voucher"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b81107447 = messageFormatterFn((function(  ) {
  return function(d) { return "No, keep 100% refund"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1234674810 = messageFormatterFn((function(  ) {
  return function(d) { return "Get a " + d["0"] + "% voucher for your hotel cancellation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b706504641 = messageFormatterFn((function(  ) {
  return function(d) { return "For your previously cancelled hotel reservation, you can request here to receive a voucher worth " + d["0"] + "% of the value of your original hotel booking rather than a full refund. If you choose this option, you will receive this private voucher in your " + d["1"] + " account within 30 days. We will contact you when your coupon is available."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b706503680 = messageFormatterFn((function(  ) {
  return function(d) { return "You must sign in to your " + d["0"] + " account to access the coupon code. If you do not have an account with " + d["0"] + ", we will create one for you using " + d["1"] + ". We will create a temporary password for you and ask you to set a new password when you sign in for the first time."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b706502719 = messageFormatterFn((function(  ) {
  return function(d) { return "Would you like to receive this voucher?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1451396439 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, get a " + d["0"] + "% " + d["1"] + " voucher, I confirm that I would like to receive a voucher worth " + d["0"] + "% of the value of my original booking."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2026373746 = messageFormatterFn((function(  ) {
  return function(d) { return "Read the terms and conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1521283852 = messageFormatterFn((function(  ) {
  return function(d) { return "Thank you! Your choice has been updated"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2125229563 = messageFormatterFn((function(  ) {
  return function(d) { return "If you elected to receive the " + d["0"] + "% voucher, you will receive it within 30 days in the same " + d["1"] + " account you used to make the original booking; just sign in to access it."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2125228602 = messageFormatterFn((function(  ) {
  return function(d) { return "If you do not have an account with " + d["0"] + ", we will create one for you. We will create a temporary password for you and ask you to set a new password when you sign in for the first time."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2125227641 = messageFormatterFn((function(  ) {
  return function(d) { return "If you elected to keep the 100% refund, no further action is needed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a974523663 = messageFormatterFn((function(  ) {
  return function(d) { return "We're sorry, but the offer to exchange your full refund for a voucher has expired. Your cash refund will be credited to your original method of payment as agreed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1759797000 = messageFormatterFn((function(  ) {
  return function(d) { return "We’re sorry, something has gone wrong. We will credit your full refund back to your original method of payment as agreed. We apologize for any inconvenience."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b946571032 = messageFormatterFn((function(  ) {
  return function(d) { return "Something went wrong."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a83636360 = messageFormatterFn((function(  ) {
  return function(d) { return "We can't give you a refund because you already requested a coupon. We're processing your coupon request now."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1026212167 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Voucher"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1906616322 = messageFormatterFn((function(  ) {
  return function(d) { return "This voucher is issued by " + d["0"] + " to certain customers impacted by the Covid-19 Coronavirus. If you have elected to receive this voucher, you are bound by the terms and conditions set forth herein. This voucher will be issued for the full amount of your cancelled travel booking, including taxes/tax recovery charges and fees, if any, originally charged (“Base Value”) plus an additional promotional amount equal to a percentage of the base value (“Promotional Value”).  You acknowledge that the Base Value you receive in the form of this voucher constitutes a full refund of any room rental amount, facilitation and service fees, and taxes/tax recovery charges charged to you on your original booking."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1906615361 = messageFormatterFn((function(  ) {
  return function(d) { return "Qualifying Bookings: This voucher applies only to stand-alone hotel bookings made online at <a href=\"" + d["0"] + "\">" + d["1"] + "</a> that are prepaid at the time of booking (subject to the restrictions set out in the terms and conditions below)."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1906614400 = messageFormatterFn((function(  ) {
  return function(d) { return "Redemption Period: The voucher does not expire."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1368091682 = messageFormatterFn((function(  ) {
  return function(d) { return "How to use your voucher"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b5952875 = messageFormatterFn((function(  ) {
  return function(d) { return "You must make your stand-alone hotel booking with <a href=\"" + d["0"] + "\">" + d["1"] + "</a>"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b5951914 = messageFormatterFn((function(  ) {
  return function(d) { return "Use the website to search for your desired stay dates."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b5950953 = messageFormatterFn((function(  ) {
  return function(d) { return "You must be signed in to your " + d["0"] + " user account to use the voucher.  If you do not yet have a " + d["0"] + " account, you will need to create an account prior to the voucher being issued. This voucher may not be applied to guest account bookings."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b5949992 = messageFormatterFn((function(  ) {
  return function(d) { return "During the booking process, on the payment page you will see the link ”Enter coupon or promotional code” where a code needs to be entered."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b5949031 = messageFormatterFn((function(  ) {
  return function(d) { return "Enter the voucher code in the relevant field, then click the “Apply Coupon” link. If your booking is eligible, the applicable amount will be subtracted from the price of the travel reservation but cannot be applied against any taxes/tax recovery charges, applicable fees, additional costs, or other fees/charges detailed in paragraph 2 below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1119421151 = messageFormatterFn((function(  ) {
  return function(d) { return "Terms and Conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813407338 = messageFormatterFn((function(  ) {
  return function(d) { return "Subject to the restrictions set out in these terms and conditions and in compliance with the above, the voucher may be applied to a pre-pay stand-alone hotel booking (not a hotel booking in combination with any other product such as flight + hotel or flight + hotel + car) online with <a href=\"" + d["0"] + "\">" + d["1"] + "</a>.  The voucher can only be used for pre-pay bookings and cannot be redeemed against bookings which are paid at the destination."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813406377 = messageFormatterFn((function(  ) {
  return function(d) { return "The voucher cannot be redeemed against taxes/tax recovery charges, supplier fees, cancellation or change fees/penalties, administrative fees, service fees or other miscellaneous charges, which are the sole responsibility of the customer."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813405416 = messageFormatterFn((function(  ) {
  return function(d) { return "Usual booking terms and conditions apply (see <a href=\"" + d["0"] + "\">" + d["1"] + "</a>) and all bookings are subject to availability."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813404455 = messageFormatterFn((function(  ) {
  return function(d) { return "The voucher may not be used with other coupons, promotions or special offers. Limit of one voucher per qualifying hotel booking."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813403494 = messageFormatterFn((function(  ) {
  return function(d) { return "The voucher cannot be used for any booking previously made.  It will be deemed fully redeemed once a qualifying booking has been made. If your booking amount is less than the voucher amount, you will receive the balance in the form of another voucher. The voucher may not be re-used, even in the event that you change or cancel your booking. If you change or cancel a booking you made with the voucher, any balance will be remitted to you in the form of another voucher. Where cash refunds of unused portions of the voucher are required by law, refunds will be limited to the Base Value only, but not any remaining Promotional Value. The Base Value of the voucher will be deemed to have been redeemed first, followed by the Promotional Value."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813402533 = messageFormatterFn((function(  ) {
  return function(d) { return "The voucher is void where prohibited by law and may only be used by the intended recipient who must be aged 18 and over."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813401572 = messageFormatterFn((function(  ) {
  return function(d) { return "Improper use of the voucher by you including but not limited to publication or selling of the voucher is prohibited and may constitute fraud. "; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813400611 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " reserves the right to change or withdraw this offer at any time and to cancel any bookings made where the voucher was improperly obtained or used to make any speculative, false, or fraudulent bookings."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1813399650 = messageFormatterFn((function(  ) {
  return function(d) { return "This offer is from Expedia, Inc."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b381040912 = messageFormatterFn((function(  ) {
  return function(d) { return "Terms and conditions of this voucher are as written and cannot be changed by any representation of any unauthorized person, including employees of Expedia, Inc.  These terms and conditions shall be governed by and construed in accordance with the laws of Washington State, USA."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b381039951 = messageFormatterFn((function(  ) {
  return function(d) { return "Any and all disputes relating to this voucher (“Claims”) will be resolved by binding arbitration, rather than in court, except you may assert Claims on an individual basis in small claims court if they qualify. This includes any Claims you assert against us, our subsidiaries, travel suppliers or any companies offering products or services through us (which are beneficiaries of this arbitration agreement). Any and all proceedings to resolve Claims will be conducted only on an individual basis and not in a class, consolidated or representative action. If for any reason a Claim proceeds in court rather than in arbitration we each waive any right to a jury trial. The U.S. Federal Arbitration Act and U.S. federal arbitration law apply to these terms and conditions. An arbitration decision may be confirmed by any court with competent jurisdiction."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b560717122 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1728338476 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your reservation at " + d["0"] + " by " + d["1"] + " and choose one of the following:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1728337515 = messageFormatterFn((function(  ) {
  return function(d) { return "A voucher in the form of a coupon worth " + d["0"] + "% of your original purchase price that you can use toward a future lodging reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1728336554 = messageFormatterFn((function(  ) {
  return function(d) { return "A 100% refund credited to your original form of payment"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1728335593 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose to cancel, and you won’t have to pay a cancellation fee. Please note: It may take up to 30 days to process your coupon or refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1743691654 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Cancel and give me a " + d["0"] + "% coupon or Cancel and give me a 100% refund, I confirm that I want " + d["1"] + " to cancel my reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1148414489 = messageFormatterFn((function(  ) {
  return function(d) { return "Read the voucher terms and conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b823597339 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel and give me a " + d["0"] + "% coupon"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2139529608 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel and give me a 100% refund"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b181677504 = messageFormatterFn((function(  ) {
  return function(d) { return "Don't cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a834404085 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1079130566 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send a confirmation to " + d["0"] + " within the next 24 hours. It may take up to 30 days for you to receive your 100% refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a687577903 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll contact you when your coupon is ready. You will be able to access it in the same account that you used when you made your original reservation. If you don’t have an account, we will create one for you using " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a687578864 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Please note</b>: It may take up to 30 days for you to receive your " + d["0"] + "% coupon."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1141351159 = messageFormatterFn((function(  ) {
  return function(d) { return "Your reservation is still active"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a728139916 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you want to keep your reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1780525584 = messageFormatterFn((function(  ) {
  return function(d) { return "We're working on it"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a449070178 = messageFormatterFn((function(  ) {
  return function(d) { return "It looks like you already submitted this request."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a449071139 = messageFormatterFn((function(  ) {
  return function(d) { return "We will begin processing your request as soon as we can. We are prioritizing requests by travel date, and processing those with the nearest travel dates first. In some cases, we may not be able to respond until after your travel is scheduled to begin. No further action is required on your part, even if you don't hear from us right away."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a449072100 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Please note:</b> Any reimbursement may take up to 30 days to process."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1968809122 = messageFormatterFn((function(  ) {
  return function(d) { return "We're sorry"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1028782413 = messageFormatterFn((function(  ) {
  return function(d) { return "We can't find that itinerary or confirmation number. Please check the number and try again. You can find the number in the email you received from us when you first made your reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1210230592 = messageFormatterFn((function(  ) {
  return function(d) { return "We're unable to process your request."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1210231553 = messageFormatterFn((function(  ) {
  return function(d) { return "Important: Use this form only for travel dates through 31 May 2020. If your travel start date is after 31 May 2020, please check back. Many of our travel partners are currently offering revised policies through 31 May 2020. Checking back will help ensure that the most recent updates apply to your travel plans."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1633057429 = messageFormatterFn((function(  ) {
  return function(d) { return "Your airline handles all cancellations. Please contact the airline directly."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1096502727 = messageFormatterFn((function(  ) {
  return function(d) { return "Something went wrong. Please try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b398617663 = messageFormatterFn((function(  ) {
  return function(d) { return "We either don't recognize that email address or the email address doesn't match the email address for the itinerary number you provided. Please use the same email address that you used when you made the original reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1097182801 = messageFormatterFn((function(  ) {
  return function(d) { return "We don't recognize that phone number. Please use the same phone number that you used when you made the original reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b647485021 = messageFormatterFn((function(  ) {
  return function(d) { return "We're unable to process your cancellation because it is less than 24 hours before your travel date. For more information, please sign in to your account and review your online itinerary."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1048184360 = messageFormatterFn((function(  ) {
  return function(d) { return "We are able to cancel some of your reservations, but we aren't able to cancel all of them. For the reservations we can't cancel, please contact the provider directly."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1048185321 = messageFormatterFn((function(  ) {
  return function(d) { return "You can use your online itinerary to find out which reservations still need to be cancelled. Please note: It may take up to 72 hours for cancellations that are currently in progress to appear as cancelled in your itinerary."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1458299473 = messageFormatterFn((function(  ) {
  return function(d) { return "All reservations for this itinerary have already been cancelled. For more information, please sign in to your account and review your online itinerary."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1822458853 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-in date has passed. Unfortunately, we are no longer able to process your cancellation or issue a refund or voucher."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a655971731 = messageFormatterFn((function(  ) {
  return function(d) { return "Unfortunately, we can't process your request because it is too close to your cancellation date. Please check your itinerary for more information about how to contact us."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2006172667 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flights by " + d["0"] + ", and the airline will give you an airline credit in the amount of the original ticket price. You can use this credit for a future flight with the same airline. If you choose to cancel, we'll cancel the following flights:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2006169784 = messageFormatterFn((function(  ) {
  return function(d) { return "If the airline has already cancelled your reservation, you can ignore this message.  If you have a package, this won't cancel any other package components."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1098470301 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your " + d["0"] + " flight by " + d["1"] + ", and the airline will give you an airline credit in the amount of the original ticket price. You can use this credit for a future flight with the same airline. If you choose to cancel, we'll cancel the following flights:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b399436181 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your trip to " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b982789138 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your trip and we'll process your cancellation as outlined in your itinerary."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b982788177 = messageFormatterFn((function(  ) {
  return function(d) { return "We will cancel all of the following reservations for this trip. Any reservations that have already been cancelled will not be affected."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a473927583 = messageFormatterFn((function(  ) {
  return function(d) { return "Unfortunately, because of the nature of the following ticket(s), we’re unable to cancel for you. Please contact the airline directly to make any changes."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2122428831 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": " + d["1"] + " - " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1014675227 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " rental"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2025220573 = messageFormatterFn((function(  ) {
  return function(d) { return "1 activity"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a940003530 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " activities"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1800974013 = messageFormatterFn((function(  ) {
  return function(d) { return "1 airport transportation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b30061142 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " airport transportations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b982786255 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want to cancel your trip?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1209459866 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my trip, I confirm that I want to cancel all of the reservations in my itinerary that have not already been cancelled."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b165079976 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my trip, I confirm that I want to cancel all of the reservations in the first list that have not already been cancelled."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1597659875 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, cancel my trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b155044882 = messageFormatterFn((function(  ) {
  return function(d) { return "No, don't cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a666151560 = messageFormatterFn((function(  ) {
  return function(d) { return "We have submitted your request to cancel your trip to " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b588448527 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send you a confirmation email in the coming weeks."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b588447566 = messageFormatterFn((function(  ) {
  return function(d) { return "In some cases, we may not be able to respond until after your travel is scheduled to begin. No further action is required on your part, even if you don't hear from us right away."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b588446605 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Please note:</b> With the significant increase in cancellations across the travel industry, any credits, coupons, or refunds may be delayed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1873567786 = messageFormatterFn((function(  ) {
  return function(d) { return "After " + d["0"] + ", if you choose to change or cancel your flight, the original fare rules will apply. This means that flight changes, refunds, and credits may not be allowed."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a493565076 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>Please note:</b> If this flight is part of a vacation package, we will only cancel your flight. You will have to cancel any remaining parts of your package individually."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b432664603 = messageFormatterFn((function(  ) {
  return function(d) { return "You may be eligible for a refund"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1214504116 = messageFormatterFn((function(  ) {
  return function(d) { return "You recently received an airline credit for a cancelled flight that you booked through us. You may be eligible for a refund in place of your airline credit for the following booking:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a156166001 = messageFormatterFn((function(  ) {
  return function(d) { return "Airline confirmation: " + d["0"] + " (" + d["1"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1214506038 = messageFormatterFn((function(  ) {
  return function(d) { return "In place of the existing credit for the above flight, you may be eligible for a refund. If you qualify, we will request a refund for you, from the airline, in the amount of the original ticket price, credited to your original form of payment. To request a refund, click below by " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1554499607 = messageFormatterFn((function(  ) {
  return function(d) { return "Please note: Due to the high volume of COVID-19-related flight cancellations, any refund may take 12 weeks or more to process, depending on the airline. Your refund will not include any non-refundable booking fees you were charged at the time of purchase."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1214506999 = messageFormatterFn((function(  ) {
  return function(d) { return "This refund request is only for the flight listed above. If you booked additional flights that may be eligible for a refund, we'll send you an email for each flight. If you booked a vacation package, this request only covers the flight portion of your package."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1214507960 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want us to request a refund for you?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1176231444 = messageFormatterFn((function(  ) {
  return function(d) { return "By choosing Yes, I want a refund, I agree to forego my airline credit if I'm able to get a refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b271926891 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, I want a refund"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a966393931 = messageFormatterFn((function(  ) {
  return function(d) { return "No, I want to keep my airline credit"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1333690926 = messageFormatterFn((function(  ) {
  return function(d) { return "We have requested a refund for you"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2041576935 = messageFormatterFn((function(  ) {
  return function(d) { return "We have sent a refund request to the airline on your behalf. If you qualify, the refund will be in the amount of the original ticket price and credited to your original form of payment. If the airline cannot give you a refund, your airline credit will still be available in your account."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2041577896 = messageFormatterFn((function(  ) {
  return function(d) { return "Please note: Due to the high volume of COVID-19-related flight cancellations, any refund may take 12 weeks or more to process, depending on the airline. No further action is required on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1727692765 = messageFormatterFn((function(  ) {
  return function(d) { return "Thank you"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a991834044 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you want to keep your airline credit. You can find information about how to use your credit in your account."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b420337473 = messageFormatterFn((function(  ) {
  return function(d) { return "Your refund request"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b769129958 = messageFormatterFn((function(  ) {
  return function(d) { return "You recently received an airline credit for a flight with " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b769128036 = messageFormatterFn((function(  ) {
  return function(d) { return "If you want to request a refund, just let us know by " + d["0"] + " and a refund in the amount of the original ticket price will be credited to your original form of payment. This refund request is only for the flight listed above."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b769126114 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want us to exchange your credit for a refund?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1188558574 = messageFormatterFn((function(  ) {
  return function(d) { return "By choosing Yes, I want a refund, I agree to forego my airline credit in exchange for a refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a354633455 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, I want a refund"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1592954277 = messageFormatterFn((function(  ) {
  return function(d) { return "No, I want to keep my airline credit"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b485877960 = messageFormatterFn((function(  ) {
  return function(d) { return "Thank you"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b85045695 = messageFormatterFn((function(  ) {
  return function(d) { return "Due to the unprecedented volume of travel disruptions, there may be delays in processing reimbursements. We apologize for any wait and appreciate your patience. No further action is required on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b85044734 = messageFormatterFn((function(  ) {
  return function(d) { return "If you have not already requested or received a refund, your refund will be processed soon."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1738203465 = messageFormatterFn((function(  ) {
  return function(d) { return "Thank you"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1204711646 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you want to keep your airline credit. You can find information about how to use your credit in your account."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b661602331 = messageFormatterFn((function(  ) {
  return function(d) { return "If you request a refund, the amount of the original ticket price will be credited to your original form of payment. This refund request is only for the flight listed above."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b661601370 = messageFormatterFn((function(  ) {
  return function(d) { return "If you want to exchange your credit for a refund, please call our customer service at " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1984250705 = messageFormatterFn((function(  ) {
  return function(d) { return "Alert"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a254734743 = messageFormatterFn((function(  ) {
  return function(d) { return "Opens in a new window"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2097054602 = messageFormatterFn((function(  ) {
  return function(d) { return "Search"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b419110879 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels and flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a946421847 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels and cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b875825336 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels, flights, and cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1578188903 = messageFormatterFn((function(  ) {
  return function(d) { return "Get availability"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1488158984 = messageFormatterFn((function(  ) {
  return function(d) { return "Get prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1349385503 = messageFormatterFn((function(  ) {
  return function(d) { return "Get deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a576460715 = messageFormatterFn((function(  ) {
  return function(d) { return "To continue, please correct the errors below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b215200838 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "To continue, please correct the " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " errors";}, one: function() { return "error";}, two: function() { return number(d["0"]) + " errors";}, few: function() { return number(d["0"]) + " errors";}, many: function() { return number(d["0"]) + " errors";}, other: function() { return number(d["0"]) + " errors";} }) + " below."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a519544992 = messageFormatterFn((function(  ) {
  return function(d) { return "Go to the error"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b188371341 = messageFormatterFn((function(  ) {
  return function(d) { return "Go to the first error"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1158432700 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "-" + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " nights";}, one: function() { return number(d["1"]) + " night";}, two: function() { return number(d["1"]) + " nights";}, few: function() { return number(d["1"]) + " nights";}, many: function() { return number(d["1"]) + " nights";}, other: function() { return number(d["1"]) + " nights";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1917876400 = messageFormatterFn((function(  ) {
  return function(d) { return "Select date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b671046770 = messageFormatterFn((function(  ) {
  return function(d) { return "Select dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1036536690 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid check in date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a112966941 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid check out date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2008020501 = messageFormatterFn((function(  ) {
  return function(d) { return "Add check-out date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b81719190 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid departing date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b362599258 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid returning date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1080136068 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid pick-up date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a878397560 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid drop-off date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a339639391 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid from date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1195096786 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid to date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a981471722 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-in date must fall within your departing and returning dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1811259325 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-out date must fall within your departing and returning dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a91139252 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-in date must fall in your departure date or after"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1735391489 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Dates must be no more than " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " days";}, one: function() { return number(d["0"]) + " day";}, two: function() { return number(d["0"]) + " days";}, few: function() { return number(d["0"]) + " days";}, many: function() { return number(d["0"]) + " days";}, other: function() { return number(d["0"]) + " days";} }) + " apart"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b546902969 = messageFormatterFn((function(  ) {
  return function(d) { return "Check out date must be after check in date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1897701114 = messageFormatterFn((function(  ) {
  return function(d) { return "Check out date must be within 28 days of check in date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a810240038 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " rooms";}, one: function() { return number(d["0"]) + " room";}, two: function() { return number(d["0"]) + " rooms";}, few: function() { return number(d["0"]) + " rooms";}, many: function() { return number(d["0"]) + " rooms";}, other: function() { return number(d["0"]) + " rooms";} }) + ", " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " travellers";}, one: function() { return number(d["1"]) + " traveller";}, two: function() { return number(d["1"]) + " travellers";}, few: function() { return number(d["1"]) + " travellers";}, many: function() { return number(d["1"]) + " travellers";}, other: function() { return number(d["1"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1500453569 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " travellers";}, one: function() { return number(d["0"]) + " traveller";}, two: function() { return number(d["0"]) + " travellers";}, few: function() { return number(d["0"]) + " travellers";}, many: function() { return number(d["0"]) + " travellers";}, other: function() { return number(d["0"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b885440855 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1521665163 = messageFormatterFn((function(  ) {
  return function(d) { return "Guests"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a828315659 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the Traveller Selector without saving changes. Or, edit the traveller information below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1376669095 = messageFormatterFn((function(  ) {
  return function(d) { return "Add another room"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a648091809 = messageFormatterFn((function(  ) {
  return function(d) { return "Request 9+ hotel rooms"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1778086325 = messageFormatterFn((function(  ) {
  return function(d) { return "Adults"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2125042816 = messageFormatterFn((function(  ) {
  return function(d) { return "Child " + d["0"] + " age"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a294971738 = messageFormatterFn((function(  ) {
  return function(d) { return "Infant " + d["0"] + " age"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b368417542 = messageFormatterFn((function(  ) {
  return function(d) { return "Ages 0 to 17"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a215676275 = messageFormatterFn((function(  ) {
  return function(d) { return "Ages 2 to 17"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1794325320 = messageFormatterFn((function(  ) {
  return function(d) { return "Younger than 2"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b48042433 = messageFormatterFn((function(  ) {
  return function(d) { return "Younger than 1"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b669281807 = messageFormatterFn((function(  ) {
  return function(d) { return "Infants"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1445877521 = messageFormatterFn((function(  ) {
  return function(d) { return "Children"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1253019195 = messageFormatterFn((function(  ) {
  return function(d) { return "Ages 12+"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1869457419 = messageFormatterFn((function(  ) {
  return function(d) { return "Ages 2 to 11"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1583588473 = messageFormatterFn((function(  ) {
  return function(d) { return "Younger than 2"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a141766199 = messageFormatterFn((function(  ) {
  return function(d) { return "Child " + d["0"] + ", age " + d["1"] + " updated."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a379451281 = messageFormatterFn((function(  ) {
  return function(d) { return "Infant " + d["0"] + ", age " + d["1"] + " updated."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a249841975 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease adults in room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b333245327 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease children in room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a293236655 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease infants in room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a945836471 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease adults"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1920897137 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease children"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b699223505 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease infants"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1380075805 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1042123027 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase adults in room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a839634253 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase children in room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1264308794 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase infants in room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1676826989 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase adults"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1607852467 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase children"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a315526534 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase infants"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a700636250 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove room"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b234988190 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove room " + d["0"] + " of " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b539675128 = messageFormatterFn((function(  ) {
  return function(d) { return "Room " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a598910892 = messageFormatterFn((function(  ) {
  return function(d) { return "Room " + d["0"] + " of " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a697064481 = messageFormatterFn((function(  ) {
  return function(d) { return "Room " + d["0"] + " added. Edit traveller information below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2066380484 = messageFormatterFn((function(  ) {
  return function(d) { return "Traveller Selector opened. Edit the traveller information below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1067691007 = messageFormatterFn((function(  ) {
  return function(d) { return "Room removed. Edit room " + d["0"] + " traveller information below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1296349731 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 1"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b177053665 = messageFormatterFn((function(  ) {
  return function(d) { return "Swap origin and destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a845181859 = messageFormatterFn((function(  ) {
  return function(d) { return "Origin and destination have been swapped"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1141559440 = messageFormatterFn((function(  ) {
  return function(d) { return "Select a destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a428522614 = messageFormatterFn((function(  ) {
  return function(d) { return "Please choose a different destination from origin"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1740417056 = messageFormatterFn((function(  ) {
  return function(d) { return "We are only able to book between 1 and 6 travellers for Packages. Please adjust the number of travellers for your search."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b170643056 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We are only able to book between 1 and " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " travellers";}, one: function() { return number(d["0"]) + " traveller";}, two: function() { return number(d["0"]) + " travellers";}, few: function() { return number(d["0"]) + " travellers";}, many: function() { return number(d["0"]) + " travellers";}, other: function() { return number(d["0"]) + " travellers";} }) + ". Please adjust the number of travellers for your search."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2107761228 = messageFormatterFn((function(  ) {
  return function(d) { return "We allow up to 6 travellers per booking."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1032110179 = messageFormatterFn((function(  ) {
  return function(d) { return "There must be at least 1 traveller (age " + d["0"] + "+) for each infant in a lap."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b978757738 = messageFormatterFn((function(  ) {
  return function(d) { return "Please provide the ages of children."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1079015526 = messageFormatterFn((function(  ) {
  return function(d) { return "Please provide the age of the child."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a862063869 = messageFormatterFn((function(  ) {
  return function(d) { return "Please provide the ages of infants."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1424328742 = messageFormatterFn((function(  ) {
  return function(d) { return "Please provide the age of the infant."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1398887454 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sorry, there can’t be more than " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " infants";}, one: function() { return number(d["0"]) + " infant";}, two: function() { return number(d["0"]) + " infants";}, few: function() { return number(d["0"]) + " infants";}, many: function() { return number(d["0"]) + " infants";}, other: function() { return number(d["0"]) + " infants";} }) + " per traveller (age " + d["1"] + "+) in your booking."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1304694574 = messageFormatterFn((function(  ) {
  return function(d) { return "Going to"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1990535336 = messageFormatterFn((function(  ) {
  return function(d) { return "Going to"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a706537258 = messageFormatterFn((function(  ) {
  return function(d) { return "Going to"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a790353962 = messageFormatterFn((function(  ) {
  return function(d) { return "Going to"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a365880424 = messageFormatterFn((function(  ) {
  return function(d) { return "Leaving from"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1515773740 = messageFormatterFn((function(  ) {
  return function(d) { return "Leaving from"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a692935922 = messageFormatterFn((function(  ) {
  return function(d) { return "Departing"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1898908214 = messageFormatterFn((function(  ) {
  return function(d) { return "Returning"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2100127659 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose dates to view prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1038205387 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose a destination and select dates to see prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a606692201 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose your dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1860566404 = messageFormatterFn((function(  ) {
  return function(d) { return "Flying from"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b290314137 = messageFormatterFn((function(  ) {
  return function(d) { return "City or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1786292374 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select an origin"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a470005870 = messageFormatterFn((function(  ) {
  return function(d) { return "Flying to"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1683841005 = messageFormatterFn((function(  ) {
  return function(d) { return "City or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b717498228 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight type"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b493692316 = messageFormatterFn((function(  ) {
  return function(d) { return "Roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1443056309 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b74488178 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b830916448 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1185471432 = messageFormatterFn((function(  ) {
  return function(d) { return "First class"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1828085991 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium economy"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1702995783 = messageFormatterFn((function(  ) {
  return function(d) { return "Preferred class"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1232307721 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the preferred class selector without saving changes. Or, choose another preferred class below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1295945612 = messageFormatterFn((function(  ) {
  return function(d) { return "Tell us where you're flying from."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1846010988 = messageFormatterFn((function(  ) {
  return function(d) { return "Tell us where you're flying to."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1777773455 = messageFormatterFn((function(  ) {
  return function(d) { return "Add another flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a694371594 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove flight leg"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1236043526 = messageFormatterFn((function(  ) {
  return function(d) { return "Airline age rules"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b279419061 = messageFormatterFn((function(  ) {
  return function(d) { return "Where will the infant sit?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1062128145 = messageFormatterFn((function(  ) {
  return function(d) { return "Where will the infants sit?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a257433271 = messageFormatterFn((function(  ) {
  return function(d) { return "In seat"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1184970107 = messageFormatterFn((function(  ) {
  return function(d) { return "On lap"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1995417311 = messageFormatterFn((function(  ) {
  return function(d) { return "Search for travel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1658901442 = messageFormatterFn((function(  ) {
  return function(d) { return "For expert cruise advice, call 1-888-444-1695."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a759790690 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodation name, city, or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a645432325 = messageFormatterFn((function(  ) {
  return function(d) { return "Build a trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1188921804 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose two or more items:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1114790182 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose two or more items to start building your trip:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1056828270 = messageFormatterFn((function(  ) {
  return function(d) { return "Vacation length"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1329529363 = messageFormatterFn((function(  ) {
  return function(d) { return "Preferred flight class"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b375990183 = messageFormatterFn((function(  ) {
  return function(d) { return "I only need accommodations for part of my trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1345869492 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select another item"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1026681727 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select another item to start building your trip."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b222237421 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select two or more items"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1187924267 = messageFormatterFn((function(  ) {
  return function(d) { return "To start building your trip, choose two or more items"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b24818679 = messageFormatterFn((function(  ) {
  return function(d) { return "Packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a961807929 = messageFormatterFn((function(  ) {
  return function(d) { return "Packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a210941091 = messageFormatterFn((function(  ) {
  return function(d) { return "City or attraction"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b597464800 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight and car packages can only be booked with one accommodation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1071466266 = messageFormatterFn((function(  ) {
  return function(d) { return "One-way"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1938224744 = messageFormatterFn((function(  ) {
  return function(d) { return "Multi-city"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2037567860 = messageFormatterFn((function(  ) {
  return function(d) { return "Business class"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1629370041 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b206544520 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove flight " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a316330425 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight " + d["0"] + " has been removed"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a469698920 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up and drop-off"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1117037858 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a36130689 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a328739632 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1180355761 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1250643860 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a175558398 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1028057147 = messageFormatterFn((function(  ) {
  return function(d) { return "Rental car company"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1626533101 = messageFormatterFn((function(  ) {
  return function(d) { return "Discount type"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1250496573 = messageFormatterFn((function(  ) {
  return function(d) { return "Include AARP member rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a632742085 = messageFormatterFn((function(  ) {
  return function(d) { return "Membership is required and verified at pick-up."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a469210417 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Driver under " + d["0"] + " or over " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " years";}, one: function() { return number(d["1"]) + " year";}, two: function() { return number(d["1"]) + " years";}, few: function() { return number(d["1"]) + " years";}, many: function() { return number(d["1"]) + " years";}, other: function() { return number(d["1"]) + " years";} }) + " old"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1173542514 = messageFormatterFn((function(  ) {
  return function(d) { return "Young or senior drivers may be required to pay an additional fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1180963908 = messageFormatterFn((function(  ) {
  return function(d) { return "Driver’s age"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1734873651 = messageFormatterFn((function(  ) {
  return function(d) { return "Please provide the driver's age"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b90910505 = messageFormatterFn((function(  ) {
  return function(d) { return "I want to rent a car somewhere else"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a460345148 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel name"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1238823333 = messageFormatterFn((function(  ) {
  return function(d) { return "Property name"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a78609811 = messageFormatterFn((function(  ) {
  return function(d) { return "Looking for sports, concerts or theatre events?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1119579405 = messageFormatterFn((function(  ) {
  return function(d) { return "Looking for sports, concerts, or music festivals?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1975287357 = messageFormatterFn((function(  ) {
  return function(d) { return "Search event tickets"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1405931659 = messageFormatterFn((function(  ) {
  return function(d) { return "Things to do in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1259433424 = messageFormatterFn((function(  ) {
  return function(d) { return "Activities in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a463420249 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a place to stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1932908621 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1926081927 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a52002220 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove a hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2063851610 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove a flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1894714764 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove a car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1024601855 = messageFormatterFn((function(  ) {
  return function(d) { return "Direct flights only"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b893876523 = messageFormatterFn((function(  ) {
  return function(d) { return "You can only add a flight or car when you have booked six rooms or less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1279863187 = messageFormatterFn((function(  ) {
  return function(d) { return "You can only add a flight or car when there are six travellers or less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a211188000 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight + hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1271664842 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight + hotel + car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1331931648 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight + car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a622601830 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel + car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a810387719 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1570831466 = messageFormatterFn((function(  ) {
  return function(d) { return "I only need a hotel for part of my stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b632138304 = messageFormatterFn((function(  ) {
  return function(d) { return "Origin"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a455695894 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1956362503 = messageFormatterFn((function(  ) {
  return function(d) { return "City or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1112551841 = messageFormatterFn((function(  ) {
  return function(d) { return "Your departing date must occur after your previous flight’s departing date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1764061666 = messageFormatterFn((function(  ) {
  return function(d) { return "Looks like you only selected one product"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a533759655 = messageFormatterFn((function(  ) {
  return function(d) { return "Select another product to start building your vacation package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1451842803 = messageFormatterFn((function(  ) {
  return function(d) { return "You have selected flights and hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1558979511 = messageFormatterFn((function(  ) {
  return function(d) { return "You have selected flights, hotels and cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1596470291 = messageFormatterFn((function(  ) {
  return function(d) { return "You have selected flights and cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1875451865 = messageFormatterFn((function(  ) {
  return function(d) { return "You have selected hotels and cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1748897933 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-in date must fall on or after your departing date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b692461080 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-out date must fall after your departing date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1365754506 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-in must fall within your first departing and last returning dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b915920325 = messageFormatterFn((function(  ) {
  return function(d) { return "Your check-out must fall within your first departing and last returning dates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a481906106 = messageFormatterFn((function(  ) {
  return function(d) { return "Find the best deals on packages and all-inclusive vacations."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a702635915 = messageFormatterFn((function(  ) {
  return function(d) { return "Leaving from"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1363574545 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a duration"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a366528977 = messageFormatterFn((function(  ) {
  return function(d) { return "Offers with transfer"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b704151568 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Book for " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " people";}, one: function() { return number(d["0"]) + " person";}, two: function() { return number(d["0"]) + " people";}, few: function() { return number(d["0"]) + " people";}, many: function() { return number(d["0"]) + " people";}, other: function() { return number(d["0"]) + " people";} }) + "+"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2143250003 = messageFormatterFn((function(  ) {
  return function(d) { return "Earliest departure"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a796229542 = messageFormatterFn((function(  ) {
  return function(d) { return "Latest return"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1852492163 = messageFormatterFn((function(  ) {
  return function(d) { return "Search All-inclusive Resorts"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b612212102 = messageFormatterFn((function(  ) {
  return function(d) { return "Staying in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1803505913 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel name, city or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b417224656 = messageFormatterFn((function(  ) {
  return function(d) { return "I want to stay somewhere else"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2096138513 = messageFormatterFn((function(  ) {
  return function(d) { return "From"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1058044568 = messageFormatterFn((function(  ) {
  return function(d) { return "To"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1290323527 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination, property name, airport, train station, landmark, or address"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a431963337 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination, accommodation name, or landmark"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a654463446 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport transportation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a134694096 = messageFormatterFn((function(  ) {
  return function(d) { return "From airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1206150623 = messageFormatterFn((function(  ) {
  return function(d) { return "To airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b914234494 = messageFormatterFn((function(  ) {
  return function(d) { return "From"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1152531795 = messageFormatterFn((function(  ) {
  return function(d) { return "To"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b575268173 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b671563426 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight arrival date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b206317379 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight arrival time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1743099673 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight departure date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2086621576 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight departure time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a27847713 = messageFormatterFn((function(  ) {
  return function(d) { return "Book roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b784924125 = messageFormatterFn((function(  ) {
  return function(d) { return "Rental cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2088741096 = messageFormatterFn((function(  ) {
  return function(d) { return "City, airport, or address"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1788868926 = messageFormatterFn((function(  ) {
  return function(d) { return "Same as pick-up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1788140291 = messageFormatterFn((function(  ) {
  return function(d) { return "Preferred brand"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1353568974 = messageFormatterFn((function(  ) {
  return function(d) { return "I have a discount code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a605705946 = messageFormatterFn((function(  ) {
  return function(d) { return "Select car brand"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a480147893 = messageFormatterFn((function(  ) {
  return function(d) { return "Add a different drop-off location"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1920875761 = messageFormatterFn((function(  ) {
  return function(d) { return "Driver's age"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a806784388 = messageFormatterFn((function(  ) {
  return function(d) { return "I don't have a code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a571498472 = messageFormatterFn((function(  ) {
  return function(d) { return "Corporate or contracted"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1686215700 = messageFormatterFn((function(  ) {
  return function(d) { return "Special or advertised"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b891631149 = messageFormatterFn((function(  ) {
  return function(d) { return "Discount rate code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1439639847 = messageFormatterFn((function(  ) {
  return function(d) { return "Discount coupon code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a572848300 = messageFormatterFn((function(  ) {
  return function(d) { return "Corporate discount " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b965314608 = messageFormatterFn((function(  ) {
  return function(d) { return "Corporate discount code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1646394910 = messageFormatterFn((function(  ) {
  return function(d) { return "FASTSTART Org ID"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1323411643 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamo Insiders " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a798434740 = messageFormatterFn((function(  ) {
  return function(d) { return "AWD " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b319434983 = messageFormatterFn((function(  ) {
  return function(d) { return "Wizard " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b522473911 = messageFormatterFn((function(  ) {
  return function(d) { return "BCD " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b212892887 = messageFormatterFn((function(  ) {
  return function(d) { return "Fast Break " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b234496902 = messageFormatterFn((function(  ) {
  return function(d) { return "Dollar Express " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b555855028 = messageFormatterFn((function(  ) {
  return function(d) { return "Customer " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1695128293 = messageFormatterFn((function(  ) {
  return function(d) { return "Enterprise Plus " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2089698944 = messageFormatterFn((function(  ) {
  return function(d) { return "Contract " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a20662103 = messageFormatterFn((function(  ) {
  return function(d) { return "Privilege " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a348711692 = messageFormatterFn((function(  ) {
  return function(d) { return "CDP"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1894073980 = messageFormatterFn((function(  ) {
  return function(d) { return "National Contract ID"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2019025518 = messageFormatterFn((function(  ) {
  return function(d) { return "Emerald Club ID"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b180013427 = messageFormatterFn((function(  ) {
  return function(d) { return "Corporate account"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1156895858 = messageFormatterFn((function(  ) {
  return function(d) { return "Payless Perks " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a527194420 = messageFormatterFn((function(  ) {
  return function(d) { return "Blue Chip " + "#"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a233518908 = messageFormatterFn((function(  ) {
  return function(d) { return "Ace Rent A Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b731487772 = messageFormatterFn((function(  ) {
  return function(d) { return "Advantage Rent-A-Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b863111759 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamo Rent A Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2049044156 = messageFormatterFn((function(  ) {
  return function(d) { return "Avis"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a240059114 = messageFormatterFn((function(  ) {
  return function(d) { return "Budget"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b295573043 = messageFormatterFn((function(  ) {
  return function(d) { return "Dollar Rent A Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1514750793 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy Rent a Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b273965050 = messageFormatterFn((function(  ) {
  return function(d) { return "Enterprise"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1272915318 = messageFormatterFn((function(  ) {
  return function(d) { return "Europcar"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b342955681 = messageFormatterFn((function(  ) {
  return function(d) { return "Fox Rent a Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b995324568 = messageFormatterFn((function(  ) {
  return function(d) { return "Hertz"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a606823358 = messageFormatterFn((function(  ) {
  return function(d) { return "Midway Car Rental"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1538557011 = messageFormatterFn((function(  ) {
  return function(d) { return "National Car Rental"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2081788390 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu Car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b137309234 = messageFormatterFn((function(  ) {
  return function(d) { return "Payless"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a554735284 = messageFormatterFn((function(  ) {
  return function(d) { return "Routes Car Rental"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b790160457 = messageFormatterFn((function(  ) {
  return function(d) { return "Sixt"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1944621949 = messageFormatterFn((function(  ) {
  return function(d) { return "Thrifty Car Rental"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1827529823 = messageFormatterFn((function(  ) {
  return function(d) { return "U-Save"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1746440741 = messageFormatterFn((function(  ) {
  return function(d) { return "Silvercar"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1995125210 = messageFormatterFn((function(  ) {
  return function(d) { return "Green Motion"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b413240978 = messageFormatterFn((function(  ) {
  return function(d) { return "NextCar"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a160896111 = messageFormatterFn((function(  ) {
  return function(d) { return "Rent-a-Wreck"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2031316689 = messageFormatterFn((function(  ) {
  return function(d) { return "Priceless"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a994694911 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1784823973 = messageFormatterFn((function(  ) {
  return function(d) { return "00:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b101191870 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1414256542 = messageFormatterFn((function(  ) {
  return function(d) { return "00:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1159015199 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1620503685 = messageFormatterFn((function(  ) {
  return function(d) { return "01:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a63128418 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1578576830 = messageFormatterFn((function(  ) {
  return function(d) { return "01:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1288097918 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1491420966 = messageFormatterFn((function(  ) {
  return function(d) { return "02:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a192211137 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1707659549 = messageFormatterFn((function(  ) {
  return function(d) { return "02:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1417180637 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1362338247 = messageFormatterFn((function(  ) {
  return function(d) { return "03:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a321293856 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1836742268 = messageFormatterFn((function(  ) {
  return function(d) { return "03:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1546263356 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1233255528 = messageFormatterFn((function(  ) {
  return function(d) { return "04:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a450376575 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1965824987 = messageFormatterFn((function(  ) {
  return function(d) { return "04:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1675346075 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1104172809 = messageFormatterFn((function(  ) {
  return function(d) { return "05:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a579459294 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2094907706 = messageFormatterFn((function(  ) {
  return function(d) { return "05:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1804428794 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b975090090 = messageFormatterFn((function(  ) {
  return function(d) { return "06:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a708542013 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2070976871 = messageFormatterFn((function(  ) {
  return function(d) { return "06:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1933511513 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b846007371 = messageFormatterFn((function(  ) {
  return function(d) { return "07:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a837624732 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1941894152 = messageFormatterFn((function(  ) {
  return function(d) { return "07:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2062594232 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b716924652 = messageFormatterFn((function(  ) {
  return function(d) { return "08:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a966707451 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1812811433 = messageFormatterFn((function(  ) {
  return function(d) { return "08:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2103290345 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b587841933 = messageFormatterFn((function(  ) {
  return function(d) { return "09:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1095790170 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1683728714 = messageFormatterFn((function(  ) {
  return function(d) { return "09:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a736529473 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2042989411 = messageFormatterFn((function(  ) {
  return function(d) { return "10:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b359357308 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1156091104 = messageFormatterFn((function(  ) {
  return function(d) { return "10:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a865612192 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1913906692 = messageFormatterFn((function(  ) {
  return function(d) { return "11:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b230274589 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1285173823 = messageFormatterFn((function(  ) {
  return function(d) { return "11:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b347318258 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1168130154 = messageFormatterFn((function(  ) {
  return function(d) { return "12:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1443205039 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a72243373 = messageFormatterFn((function(  ) {
  return function(d) { return "12:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b182997970 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1332450442 = messageFormatterFn((function(  ) {
  return function(d) { return "13:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1278884751 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a236563661 = messageFormatterFn((function(  ) {
  return function(d) { return "13:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b53915251 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1461533161 = messageFormatterFn((function(  ) {
  return function(d) { return "14:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1149802032 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a365646380 = messageFormatterFn((function(  ) {
  return function(d) { return "14:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a75167468 = messageFormatterFn((function(  ) {
  return function(d) { return "15:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1590615880 = messageFormatterFn((function(  ) {
  return function(d) { return "15:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1020719313 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a494729099 = messageFormatterFn((function(  ) {
  return function(d) { return "15:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a204250187 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1719698599 = messageFormatterFn((function(  ) {
  return function(d) { return "16:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b891636594 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a623811818 = messageFormatterFn((function(  ) {
  return function(d) { return "16:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a333332906 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1848781318 = messageFormatterFn((function(  ) {
  return function(d) { return "17:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b762553875 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a752894537 = messageFormatterFn((function(  ) {
  return function(d) { return "17:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a462415625 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1977864037 = messageFormatterFn((function(  ) {
  return function(d) { return "18:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b633471156 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a881977256 = messageFormatterFn((function(  ) {
  return function(d) { return "18:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a591498344 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2106946756 = messageFormatterFn((function(  ) {
  return function(d) { return "19:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b504388437 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1011059975 = messageFormatterFn((function(  ) {
  return function(d) { return "19:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a720581063 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2058937821 = messageFormatterFn((function(  ) {
  return function(d) { return "20:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b375305718 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1140142694 = messageFormatterFn((function(  ) {
  return function(d) { return "20:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a849663782 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1929855102 = messageFormatterFn((function(  ) {
  return function(d) { return "21:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b246222999 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1269225413 = messageFormatterFn((function(  ) {
  return function(d) { return "21:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b605483696 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a909964716 = messageFormatterFn((function(  ) {
  return function(d) { return "22:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1701370477 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b185922065 = messageFormatterFn((function(  ) {
  return function(d) { return "22:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b476400977 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1039047435 = messageFormatterFn((function(  ) {
  return function(d) { return "23:15"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1572287758 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b56839346 = messageFormatterFn((function(  ) {
  return function(d) { return "23:45"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1801428276 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a781186960 = messageFormatterFn((function(  ) {
  return function(d) { return "12:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2029116407 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1008875091 = messageFormatterFn((function(  ) {
  return function(d) { return "12:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a958652756 = messageFormatterFn((function(  ) {
  return function(d) { return "1:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b61588560 = messageFormatterFn((function(  ) {
  return function(d) { return "1:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1186340887 = messageFormatterFn((function(  ) {
  return function(d) { return "1:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a166099571 = messageFormatterFn((function(  ) {
  return function(d) { return "1:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a448118579 = messageFormatterFn((function(  ) {
  return function(d) { return "2:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b572122737 = messageFormatterFn((function(  ) {
  return function(d) { return "2:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a675806710 = messageFormatterFn((function(  ) {
  return function(d) { return "2:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b344434606 = messageFormatterFn((function(  ) {
  return function(d) { return "2:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b62415598 = messageFormatterFn((function(  ) {
  return function(d) { return "3:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1082656914 = messageFormatterFn((function(  ) {
  return function(d) { return "3:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a165272533 = messageFormatterFn((function(  ) {
  return function(d) { return "3:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b854968783 = messageFormatterFn((function(  ) {
  return function(d) { return "3:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b572949775 = messageFormatterFn((function(  ) {
  return function(d) { return "4:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1593191091 = messageFormatterFn((function(  ) {
  return function(d) { return "4:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b345261644 = messageFormatterFn((function(  ) {
  return function(d) { return "4:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1365502960 = messageFormatterFn((function(  ) {
  return function(d) { return "4:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1083483952 = messageFormatterFn((function(  ) {
  return function(d) { return "5:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2103725268 = messageFormatterFn((function(  ) {
  return function(d) { return "5:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b855795821 = messageFormatterFn((function(  ) {
  return function(d) { return "5:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1876037137 = messageFormatterFn((function(  ) {
  return function(d) { return "5:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1594018129 = messageFormatterFn((function(  ) {
  return function(d) { return "6:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1680707851 = messageFormatterFn((function(  ) {
  return function(d) { return "6:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1366329998 = messageFormatterFn((function(  ) {
  return function(d) { return "6:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1908395982 = messageFormatterFn((function(  ) {
  return function(d) { return "6:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2104552306 = messageFormatterFn((function(  ) {
  return function(d) { return "7:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1170173674 = messageFormatterFn((function(  ) {
  return function(d) { return "7:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1876864175 = messageFormatterFn((function(  ) {
  return function(d) { return "7:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1397861805 = messageFormatterFn((function(  ) {
  return function(d) { return "7:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1679880813 = messageFormatterFn((function(  ) {
  return function(d) { return "8:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a659639497 = messageFormatterFn((function(  ) {
  return function(d) { return "8:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1907568944 = messageFormatterFn((function(  ) {
  return function(d) { return "8:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a887327628 = messageFormatterFn((function(  ) {
  return function(d) { return "8:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1169346636 = messageFormatterFn((function(  ) {
  return function(d) { return "9:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a149105320 = messageFormatterFn((function(  ) {
  return function(d) { return "9:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1397034767 = messageFormatterFn((function(  ) {
  return function(d) { return "9:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a376793451 = messageFormatterFn((function(  ) {
  return function(d) { return "9:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1472470666 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1802255314 = messageFormatterFn((function(  ) {
  return function(d) { return "10:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1244782535 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2029943445 = messageFormatterFn((function(  ) {
  return function(d) { return "10:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1983004843 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1291721137 = messageFormatterFn((function(  ) {
  return function(d) { return "11:15 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1755316712 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1519409268 = messageFormatterFn((function(  ) {
  return function(d) { return "11:45 am"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1695350467 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a675109151 = messageFormatterFn((function(  ) {
  return function(d) { return "12:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1923038598 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a902797282 = messageFormatterFn((function(  ) {
  return function(d) { return "12:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a852574947 = messageFormatterFn((function(  ) {
  return function(d) { return "1:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b167666369 = messageFormatterFn((function(  ) {
  return function(d) { return "1:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1080263078 = messageFormatterFn((function(  ) {
  return function(d) { return "1:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a60021762 = messageFormatterFn((function(  ) {
  return function(d) { return "1:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a342040770 = messageFormatterFn((function(  ) {
  return function(d) { return "2:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b678200546 = messageFormatterFn((function(  ) {
  return function(d) { return "2:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a569728901 = messageFormatterFn((function(  ) {
  return function(d) { return "2:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b450512415 = messageFormatterFn((function(  ) {
  return function(d) { return "2:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b168493407 = messageFormatterFn((function(  ) {
  return function(d) { return "3:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1188734723 = messageFormatterFn((function(  ) {
  return function(d) { return "3:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a59194724 = messageFormatterFn((function(  ) {
  return function(d) { return "3:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b961046592 = messageFormatterFn((function(  ) {
  return function(d) { return "3:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b679027584 = messageFormatterFn((function(  ) {
  return function(d) { return "4:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1699268900 = messageFormatterFn((function(  ) {
  return function(d) { return "4:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b451339453 = messageFormatterFn((function(  ) {
  return function(d) { return "4:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1471580769 = messageFormatterFn((function(  ) {
  return function(d) { return "4:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1189561761 = messageFormatterFn((function(  ) {
  return function(d) { return "5:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2085164219 = messageFormatterFn((function(  ) {
  return function(d) { return "5:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b961873630 = messageFormatterFn((function(  ) {
  return function(d) { return "5:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1982114946 = messageFormatterFn((function(  ) {
  return function(d) { return "5:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1700095938 = messageFormatterFn((function(  ) {
  return function(d) { return "6:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1574630042 = messageFormatterFn((function(  ) {
  return function(d) { return "6:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1472407807 = messageFormatterFn((function(  ) {
  return function(d) { return "6:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1802318173 = messageFormatterFn((function(  ) {
  return function(d) { return "6:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2084337181 = messageFormatterFn((function(  ) {
  return function(d) { return "7:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1064095865 = messageFormatterFn((function(  ) {
  return function(d) { return "7:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1982941984 = messageFormatterFn((function(  ) {
  return function(d) { return "7:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1291783996 = messageFormatterFn((function(  ) {
  return function(d) { return "7:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1573803004 = messageFormatterFn((function(  ) {
  return function(d) { return "8:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a553561688 = messageFormatterFn((function(  ) {
  return function(d) { return "8:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1801491135 = messageFormatterFn((function(  ) {
  return function(d) { return "8:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a781249819 = messageFormatterFn((function(  ) {
  return function(d) { return "8:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1063268827 = messageFormatterFn((function(  ) {
  return function(d) { return "9:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a43027511 = messageFormatterFn((function(  ) {
  return function(d) { return "9:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1290956958 = messageFormatterFn((function(  ) {
  return function(d) { return "9:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a270715642 = messageFormatterFn((function(  ) {
  return function(d) { return "9:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1578548475 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1696177505 = messageFormatterFn((function(  ) {
  return function(d) { return "10:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1350860344 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1923865636 = messageFormatterFn((function(  ) {
  return function(d) { return "10:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2089082652 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1185643328 = messageFormatterFn((function(  ) {
  return function(d) { return "11:15 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1861394521 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1413331459 = messageFormatterFn((function(  ) {
  return function(d) { return "11:45 pm"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b107832252 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a pick-up time after the current time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1110559918 = messageFormatterFn((function(  ) {
  return function(d) { return "The selected time is in the past. Please adjust your selection"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a387158737 = messageFormatterFn((function(  ) {
  return function(d) { return "The departing flight must occur at least 2 hours after the arriving flight."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1630006189 = messageFormatterFn((function(  ) {
  return function(d) { return "Going to"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a735963743 = messageFormatterFn((function(  ) {
  return function(d) { return "Departs as early as"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b751610664 = messageFormatterFn((function(  ) {
  return function(d) { return "Departs as late as"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1220012469 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers in the cabin"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b901918504 = messageFormatterFn((function(  ) {
  return function(d) { return "Select destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a761798203 = messageFormatterFn((function(  ) {
  return function(d) { return "Most popular"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1836587134 = messageFormatterFn((function(  ) {
  return function(d) { return "Caribbean"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1091029428 = messageFormatterFn((function(  ) {
  return function(d) { return "Bahamas"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1213243346 = messageFormatterFn((function(  ) {
  return function(d) { return "Mexico"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b569970480 = messageFormatterFn((function(  ) {
  return function(d) { return "Alaska"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a231961535 = messageFormatterFn((function(  ) {
  return function(d) { return "Europe"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a185825689 = messageFormatterFn((function(  ) {
  return function(d) { return "Bermuda"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1237948672 = messageFormatterFn((function(  ) {
  return function(d) { return "Hawaii"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1154774420 = messageFormatterFn((function(  ) {
  return function(d) { return "Canada / New England"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b664022912 = messageFormatterFn((function(  ) {
  return function(d) { return "Other Destinations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1990594924 = messageFormatterFn((function(  ) {
  return function(d) { return "Arctic / Antarctic"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b305012913 = messageFormatterFn((function(  ) {
  return function(d) { return "Middle East"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1451638935 = messageFormatterFn((function(  ) {
  return function(d) { return "Africa"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2109221304 = messageFormatterFn((function(  ) {
  return function(d) { return "Panama Canal"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1166385639 = messageFormatterFn((function(  ) {
  return function(d) { return "Asia"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a643198613 = messageFormatterFn((function(  ) {
  return function(d) { return "Pacific Coastal"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1636165318 = messageFormatterFn((function(  ) {
  return function(d) { return "Australia / New Zealand"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1284842998 = messageFormatterFn((function(  ) {
  return function(d) { return "Central America"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a431557360 = messageFormatterFn((function(  ) {
  return function(d) { return "Galapagos"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2140777559 = messageFormatterFn((function(  ) {
  return function(d) { return "Getaway at Sea"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1442563669 = messageFormatterFn((function(  ) {
  return function(d) { return "Transatlantic"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b389639433 = messageFormatterFn((function(  ) {
  return function(d) { return "World"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a320783774 = messageFormatterFn((function(  ) {
  return function(d) { return "South America"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1042080999 = messageFormatterFn((function(  ) {
  return function(d) { return "South Pacific"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1076557570 = messageFormatterFn((function(  ) {
  return function(d) { return "Transpacific"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2111534953 = messageFormatterFn((function(  ) {
  return function(d) { return "Departure port"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1606769613 = messageFormatterFn((function(  ) {
  return function(d) { return "Sailing date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1311892057 = messageFormatterFn((function(  ) {
  return function(d) { return "Trip duration"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a227578097 = messageFormatterFn((function(  ) {
  return function(d) { return "Cruise line"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1804010849 = messageFormatterFn((function(  ) {
  return function(d) { return "Got it"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b427509148 = messageFormatterFn((function(  ) {
  return function(d) { return "Photo by " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b506665572 = messageFormatterFn((function(  ) {
  return function(d) { return "Open " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b207947092 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Photo</a><span> by </span><a href=\"" + d["1"] + "\">" + d["2"] + "</a><span> (</span><a href=\"" + d["3"] + "\">" + d["4"] + "</a><span>)</span>"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1231545407 = messageFormatterFn((function(  ) {
  return function(d) { return "<a href=\"" + d["0"] + "\">Photo</a> by " + d["1"] + " (<a href=\"" + d["2"] + "\">" + d["3"] + "</a>)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1402247091 = messageFormatterFn((function(  ) {
  return function(d) { return "Photo \"" + d["0"] + "\" by " + d["1"] + " (" + d["2"] + ") / Cropped from original"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b183284839 = messageFormatterFn((function(  ) {
  return function(d) { return "Estimated price for 1 night / 2 adults"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b556605487 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b177594692 = messageFormatterFn((function(  ) {
  return function(d) { return "Image for " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1156569310 = messageFormatterFn((function(  ) {
  return function(d) { return "Reserve now, pay when you stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b646415021 = messageFormatterFn((function(  ) {
  return function(d) { return "Free cancellation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b883506802 = messageFormatterFn((function(  ) {
  return function(d) { return "Fully refundable"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1490041964 = messageFormatterFn((function(  ) {
  return function(d) { return "Reserve now, pay when you stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1805558243 = messageFormatterFn((function(  ) {
  return function(d) { return "Free cancellation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b433473551 = messageFormatterFn((function(  ) {
  return function(d) { return "See all properties in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1057305472 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "See " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " properties";}, one: function() { return d["1"] + " property";}, two: function() { return d["1"] + " properties";}, few: function() { return "all " + d["1"] + " properties";}, many: function() { return "all " + d["1"] + " properties";}, other: function() { return "all " + d["1"] + " properties";} }) + " in " + d["2"]; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b487153216 = messageFormatterFn((function(  ) {
  return function(d) { return "See all available properties in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b960267862 = messageFormatterFn((function(  ) {
  return function(d) { return "Don't see what you're looking for?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1163221535 = messageFormatterFn((function(  ) {
  return function(d) { return "View all properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a679490925 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1483870310 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1575699801 = messageFormatterFn((function(  ) {
  return function(d) { return "See more " + d["0"] + " in " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a563447698 = messageFormatterFn((function(  ) {
  return function(d) { return "We've got more " + d["0"] + ". Find the right one for you."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1133421295 = messageFormatterFn((function(  ) {
  return function(d) { return "See more all-inclusive properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1638352501 = messageFormatterFn((function(  ) {
  return function(d) { return "See more beach properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a45900264 = messageFormatterFn((function(  ) {
  return function(d) { return "See more boutique properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b52458359 = messageFormatterFn((function(  ) {
  return function(d) { return "See more budget properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2019117124 = messageFormatterFn((function(  ) {
  return function(d) { return "See more business properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1051950791 = messageFormatterFn((function(  ) {
  return function(d) { return "See more casino properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1645785427 = messageFormatterFn((function(  ) {
  return function(d) { return "See more family-friendly properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b635955377 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a fitness centre"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2130940314 = messageFormatterFn((function(  ) {
  return function(d) { return "See more golf properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1163942026 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a kitchen"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a832253270 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a kitchenette"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b961455 = messageFormatterFn((function(  ) {
  return function(d) { return "See more luxury properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b342227403 = messageFormatterFn((function(  ) {
  return function(d) { return "See more ocean view properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a846357020 = messageFormatterFn((function(  ) {
  return function(d) { return "See more pet-friendly properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1150552864 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a pool"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1818061195 = messageFormatterFn((function(  ) {
  return function(d) { return "See more romantic properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1306458851 = messageFormatterFn((function(  ) {
  return function(d) { return "See more ski properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a113193206 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a spa"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b745951725 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a waterpark"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1019847974 = messageFormatterFn((function(  ) {
  return function(d) { return "See more properties with a wedding venue"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b439216171 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more all-inclusive hotels";}, one: function() { return number(d["0"]) + " more all-inclusive hotel";}, two: function() { return number(d["0"]) + " more all-inclusive hotels";}, few: function() { return number(d["0"]) + " more all-inclusive hotels";}, many: function() { return number(d["0"]) + " more all-inclusive hotels";}, other: function() { return number(d["0"]) + " more all-inclusive hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a397517147 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more beach hotels";}, one: function() { return number(d["0"]) + " more beach hotel";}, two: function() { return number(d["0"]) + " more beach hotels";}, few: function() { return number(d["0"]) + " more beach hotels";}, many: function() { return number(d["0"]) + " more beach hotels";}, other: function() { return number(d["0"]) + " more beach hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b802758706 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more boutique hotels";}, one: function() { return number(d["0"]) + " more boutique hotel";}, two: function() { return number(d["0"]) + " more boutique hotels";}, few: function() { return number(d["0"]) + " more boutique hotels";}, many: function() { return number(d["0"]) + " more boutique hotels";}, other: function() { return number(d["0"]) + " more boutique hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a466303855 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more budget hotels";}, one: function() { return number(d["0"]) + " more budget hotel";}, two: function() { return number(d["0"]) + " more budget hotels";}, few: function() { return number(d["0"]) + " more budget hotels";}, many: function() { return number(d["0"]) + " more budget hotels";}, other: function() { return number(d["0"]) + " more budget hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1957830102 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more business hotels";}, one: function() { return number(d["0"]) + " more business hotel";}, two: function() { return number(d["0"]) + " more business hotels";}, few: function() { return number(d["0"]) + " more business hotels";}, many: function() { return number(d["0"]) + " more business hotels";}, other: function() { return number(d["0"]) + " more business hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1643126753 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more casino hotels";}, one: function() { return number(d["0"]) + " more casino hotel";}, two: function() { return number(d["0"]) + " more casino hotels";}, few: function() { return number(d["0"]) + " more casino hotels";}, many: function() { return number(d["0"]) + " more casino hotels";}, other: function() { return number(d["0"]) + " more casino hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a611502649 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more family-friendly hotels";}, one: function() { return number(d["0"]) + " more family-friendly hotel";}, two: function() { return number(d["0"]) + " more family-friendly hotels";}, few: function() { return number(d["0"]) + " more family-friendly hotels";}, many: function() { return number(d["0"]) + " more family-friendly hotels";}, other: function() { return number(d["0"]) + " more family-friendly hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b641340363 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more hotels with a fitness centre";}, one: function() { return number(d["0"]) + " more hotel with a fitness centre";}, two: function() { return number(d["0"]) + " more hotels with a fitness centre";}, few: function() { return number(d["0"]) + " more hotels with a fitness centre";}, many: function() { return number(d["0"]) + " more hotels with a fitness centre";}, other: function() { return number(d["0"]) + " more hotels with a fitness centre";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b910013876 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more golf hotels";}, one: function() { return number(d["0"]) + " more golf hotel";}, two: function() { return number(d["0"]) + " more golf hotels";}, few: function() { return number(d["0"]) + " more golf hotels";}, many: function() { return number(d["0"]) + " more golf hotels";}, other: function() { return number(d["0"]) + " more golf hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1065905316 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more hotels with a kitchen";}, one: function() { return number(d["0"]) + " more hotel with a kitchen";}, two: function() { return number(d["0"]) + " more hotels with a kitchen";}, few: function() { return number(d["0"]) + " more hotels with a kitchen";}, many: function() { return number(d["0"]) + " more hotels with a kitchen";}, other: function() { return number(d["0"]) + " more hotels with a kitchen";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a986118460 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more hotels with a kitchenette";}, one: function() { return number(d["0"]) + " more hotel with a kitchenette";}, two: function() { return number(d["0"]) + " more hotels with a kitchenette";}, few: function() { return number(d["0"]) + " more hotels with a kitchenette";}, many: function() { return number(d["0"]) + " more hotels with a kitchenette";}, other: function() { return number(d["0"]) + " more hotels with a kitchenette";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a15026999 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more luxury hotels";}, one: function() { return number(d["0"]) + " more luxury hotel";}, two: function() { return number(d["0"]) + " more luxury hotels";}, few: function() { return number(d["0"]) + " more luxury hotels";}, many: function() { return number(d["0"]) + " more luxury hotels";}, other: function() { return number(d["0"]) + " more luxury hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b381673189 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more ocean view hotels";}, one: function() { return number(d["0"]) + " more ocean view hotel";}, two: function() { return number(d["0"]) + " more ocean view hotels";}, few: function() { return number(d["0"]) + " more ocean view hotels";}, many: function() { return number(d["0"]) + " more ocean view hotels";}, other: function() { return number(d["0"]) + " more ocean view hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a313152514 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more pet-friendly hotels";}, one: function() { return number(d["0"]) + " more pet-friendly hotel";}, two: function() { return number(d["0"]) + " more pet-friendly hotels";}, few: function() { return number(d["0"]) + " more pet-friendly hotels";}, many: function() { return number(d["0"]) + " more pet-friendly hotels";}, other: function() { return number(d["0"]) + " more pet-friendly hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2064170746 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more hotels with a pool";}, one: function() { return number(d["0"]) + " more hotel with a pool";}, two: function() { return number(d["0"]) + " more hotels with a pool";}, few: function() { return number(d["0"]) + " more hotels with a pool";}, many: function() { return number(d["0"]) + " more hotels with a pool";}, other: function() { return number(d["0"]) + " more hotels with a pool";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1643966811 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more romantic hotels";}, one: function() { return number(d["0"]) + " more romantic hotel";}, two: function() { return number(d["0"]) + " more romantic hotels";}, few: function() { return number(d["0"]) + " more romantic hotels";}, many: function() { return number(d["0"]) + " more romantic hotels";}, other: function() { return number(d["0"]) + " more romantic hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b677141559 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more ski hotels";}, one: function() { return number(d["0"]) + " more ski hotel";}, two: function() { return number(d["0"]) + " more ski hotels";}, few: function() { return number(d["0"]) + " more ski hotels";}, many: function() { return number(d["0"]) + " more ski hotels";}, other: function() { return number(d["0"]) + " more ski hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a326671580 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more spa hotels";}, one: function() { return number(d["0"]) + " more spa hotel";}, two: function() { return number(d["0"]) + " more spa hotels";}, few: function() { return number(d["0"]) + " more spa hotels";}, many: function() { return number(d["0"]) + " more spa hotels";}, other: function() { return number(d["0"]) + " more spa hotels";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b905148679 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more hotels with a waterpark";}, one: function() { return number(d["0"]) + " more hotel with a waterpark";}, two: function() { return number(d["0"]) + " more hotels with a waterpark";}, few: function() { return number(d["0"]) + " more hotels with a waterpark";}, many: function() { return number(d["0"]) + " more hotels with a waterpark";}, other: function() { return number(d["0"]) + " more hotels with a waterpark";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b829275892 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "We have " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " more hotels with a wedding venue";}, one: function() { return number(d["0"]) + " more hotel with a wedding venue";}, two: function() { return number(d["0"]) + " more hotels with a wedding venue";}, few: function() { return number(d["0"]) + " more hotels with a wedding venue";}, many: function() { return number(d["0"]) + " more hotels with a wedding venue";}, other: function() { return number(d["0"]) + " more hotels with a wedding venue";} }) + " to choose from"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1679438325 = messageFormatterFn((function(  ) {
  return function(d) { return "Open " + d["0"] + " hotel page"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a964690247 = messageFormatterFn((function(  ) {
  return function(d) { return "For 2 guests"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1470254652 = messageFormatterFn((function(  ) {
  return function(d) { return "per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1674014433 = messageFormatterFn((function(  ) {
  return function(d) { return "The price is " + d["0"] + " per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b879039486 = messageFormatterFn((function(  ) {
  return function(d) { return "The price is " + d["0"] + " per night from " + d["1"] + " to " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1473050074 = messageFormatterFn((function(  ) {
  return function(d) { return "Get rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a258087454 = messageFormatterFn((function(  ) {
  return function(d) { return "Reviewed on " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a127070212 = messageFormatterFn((function(  ) {
  return function(d) { return "Good!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a127071173 = messageFormatterFn((function(  ) {
  return function(d) { return "Very good!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a127072134 = messageFormatterFn((function(  ) {
  return function(d) { return "Excellent!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a127073095 = messageFormatterFn((function(  ) {
  return function(d) { return "Wonderful!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a127074056 = messageFormatterFn((function(  ) {
  return function(d) { return "Exceptional!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1579074461 = messageFormatterFn((function(  ) {
  return function(d) { return "Good"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1579075422 = messageFormatterFn((function(  ) {
  return function(d) { return "Very good"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1579076383 = messageFormatterFn((function(  ) {
  return function(d) { return "Excellent"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1579077344 = messageFormatterFn((function(  ) {
  return function(d) { return "Wonderful"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1579078305 = messageFormatterFn((function(  ) {
  return function(d) { return "Exceptional"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b349486075 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { 0: function() { return "No reviews";}, zero: function() { return d["1"] + " reviews";}, one: function() { return d["1"] + " review";}, two: function() { return d["1"] + " reviews";}, few: function() { return d["1"] + " reviews";}, many: function() { return d["1"] + " reviews";}, other: function() { return d["1"] + " reviews";} }); }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a2100558913 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " has been added to your lists"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a6120764 = messageFormatterFn((function(  ) {
  return function(d) { return "Save " + d["0"] + " to your lists"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1513942645 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " has been removed from your lists"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1269472206 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove " + d["0"] + " from your lists"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a641359315 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Endorsed by " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " travellers";}, one: function() { return number(d["0"]) + " traveller";}, two: function() { return number(d["0"]) + " travellers";}, few: function() { return number(d["0"]) + " travellers";}, many: function() { return number(d["0"]) + " travellers";}, other: function() { return number(d["0"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a929629500 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " mi";}, one: function() { return d["1"] + " mi";}, two: function() { return d["1"] + " mi";}, few: function() { return d["1"] + " mi";}, many: function() { return d["1"] + " mi";}, other: function() { return d["1"] + " mi";} }) + " from " + d["2"]; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1109172995 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " km";}, one: function() { return d["1"] + " km";}, two: function() { return d["1"] + " km";}, few: function() { return d["1"] + " km";}, many: function() { return d["1"] + " km";}, other: function() { return d["1"] + " km";} }) + " from " + d["2"]; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b708419345 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " min";}, one: function() { return number(d["0"]) + " min";}, two: function() { return number(d["0"]) + " min";}, few: function() { return number(d["0"]) + " min";}, many: function() { return number(d["0"]) + " min";}, other: function() { return number(d["0"]) + " min";} }) + " walk from " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a247693912 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " min";}, one: function() { return number(d["0"]) + " min";}, two: function() { return number(d["0"]) + " min";}, few: function() { return number(d["0"]) + " min";}, many: function() { return number(d["0"]) + " min";}, other: function() { return number(d["0"]) + " min";} }) + " drive from " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1483896840 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " drive from " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1228776863 = messageFormatterFn((function(  ) {
  return function(d) { return "Your filter options are not showing a match."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2137771449 = messageFormatterFn((function(  ) {
  return function(d) { return "Try adjusting your filters or see more choices below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2110689941 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose dates to view prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1846650841 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " km";}, one: function() { return d["1"] + " km";}, two: function() { return d["1"] + " km";}, few: function() { return d["1"] + " km";}, many: function() { return d["1"] + " km";}, other: function() { return d["1"] + " km";} }) + " from city centre"; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1846595103 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " mi";}, one: function() { return d["1"] + " mi";}, two: function() { return d["1"] + " mi";}, few: function() { return d["1"] + " mi";}, many: function() { return d["1"] + " mi";}, other: function() { return d["1"] + " mi";} }) + " from city centre"; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1287783651 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight package can only be booked with one hotel stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b849454686 = messageFormatterFn((function(  ) {
  return function(d) { return "Got it"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2080936335 = messageFormatterFn((function(  ) {
  return function(d) { return "I need multiple places to stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a567241314 = messageFormatterFn((function(  ) {
  return function(d) { return "Standalone rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1790626166 = messageFormatterFn((function(  ) {
  return function(d) { return "Package rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a857523638 = messageFormatterFn((function(  ) {
  return function(d) { return "New Shopping Experience"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1584130813 = messageFormatterFn((function(  ) {
  return function(d) { return "See a list of all hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a727685963 = messageFormatterFn((function(  ) {
  return function(d) { return "See a list of all hotels near " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1641590491 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1893545823 = messageFormatterFn((function(  ) {
  return function(d) { return "Next"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a930137522 = messageFormatterFn((function(  ) {
  return function(d) { return "View in a map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346594728 = messageFormatterFn((function(  ) {
  return function(d) { return "Show map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b190596469 = messageFormatterFn((function(  ) {
  return function(d) { return "Map of " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1302680803 = messageFormatterFn((function(  ) {
  return function(d) { return "Map of hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2106079617 = messageFormatterFn((function(  ) {
  return function(d) { return "Close map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a558426046 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { 0: function() { return "No reviews";}, zero: function() { return d["1"] + " reviews";}, one: function() { return d["1"] + " review";}, two: function() { return d["1"] + " reviews";}, few: function() { return d["1"] + " reviews";}, many: function() { return d["1"] + " reviews";}, other: function() { return d["1"] + " reviews";} }); }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a281299230 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " / 5"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2081530688 = messageFormatterFn((function(  ) {
  return function(d) { return "See nearby properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a724441488 = messageFormatterFn((function(  ) {
  return function(d) { return "Search this area"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1834673553 = messageFormatterFn((function(  ) {
  return function(d) { return "Your filter options are not showing a match."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b186357223 = messageFormatterFn((function(  ) {
  return function(d) { return "Try adjusting your filters."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b844814170 = messageFormatterFn((function(  ) {
  return function(d) { return "This area does not have available properties."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1646098012 = messageFormatterFn((function(  ) {
  return function(d) { return "Try moving the map to extend your search."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a307462608 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + "<br />from " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1656550542 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + "\nfrom " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1293995615 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " marker not selected"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1274350968 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " marker selected"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2092336562 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for " + d["0"] + ", " + d["1"] + " and " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2092335601 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for " + d["0"] + " and " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2092334640 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a109410898 = messageFormatterFn((function(  ) {
  return function(d) { return "Reasons to visit"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a95141667 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore city"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a724285961 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1418640419 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular cities in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1304672610 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with air conditioning"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1025015024 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " all-inclusive hotels";}, one: function() { return number(d["0"]) + " all-inclusive hotel";}, two: function() { return number(d["0"]) + " all-inclusive hotels";}, few: function() { return number(d["0"]) + " all-inclusive hotels";}, many: function() { return number(d["0"]) + " all-inclusive hotels";}, other: function() { return number(d["0"]) + " all-inclusive hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b527030219 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with balconies"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1080555884 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " beach hotels";}, one: function() { return number(d["0"]) + " beach hotel";}, two: function() { return number(d["0"]) + " beach hotels";}, few: function() { return number(d["0"]) + " beach hotels";}, many: function() { return number(d["0"]) + " beach hotels";}, other: function() { return number(d["0"]) + " beach hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1846397353 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " boutique hotels";}, one: function() { return number(d["0"]) + " boutique hotel";}, two: function() { return number(d["0"]) + " boutique hotels";}, few: function() { return number(d["0"]) + " boutique hotels";}, many: function() { return number(d["0"]) + " boutique hotels";}, other: function() { return number(d["0"]) + " boutique hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1937811956 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with breakfast"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2027735094 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " budget hotels";}, one: function() { return number(d["0"]) + " budget hotel";}, two: function() { return number(d["0"]) + " budget hotels";}, few: function() { return number(d["0"]) + " budget hotels";}, many: function() { return number(d["0"]) + " budget hotels";}, other: function() { return number(d["0"]) + " budget hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b639636731 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " business hotels";}, one: function() { return number(d["0"]) + " business hotel";}, two: function() { return number(d["0"]) + " business hotels";}, few: function() { return number(d["0"]) + " business hotels";}, many: function() { return number(d["0"]) + " business hotels";}, other: function() { return number(d["0"]) + " business hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b423581574 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " casino hotels";}, one: function() { return number(d["0"]) + " casino hotel";}, two: function() { return number(d["0"]) + " casino hotels";}, few: function() { return number(d["0"]) + " casino hotels";}, many: function() { return number(d["0"]) + " casino hotels";}, other: function() { return number(d["0"]) + " casino hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b421957154 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with childcare"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b535131676 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a concierge"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2054793807 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with connecting rooms"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a469578772 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " family-friendly hotels";}, one: function() { return number(d["0"]) + " family-friendly hotel";}, two: function() { return number(d["0"]) + " family-friendly hotels";}, few: function() { return number(d["0"]) + " family-friendly hotels";}, many: function() { return number(d["0"]) + " family-friendly hotels";}, other: function() { return number(d["0"]) + " family-friendly hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a144958702 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a fitness centre"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1857971140 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with free airport shuttle"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1254431008 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with free breakfast"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1213139517 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with free parking"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1641873447 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " golf hotels";}, one: function() { return number(d["0"]) + " golf hotel";}, two: function() { return number(d["0"]) + " golf hotels";}, few: function() { return number(d["0"]) + " golf hotels";}, many: function() { return number(d["0"]) + " golf hotels";}, other: function() { return number(d["0"]) + " golf hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b720330919 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with hot tubs"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1087856116 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with an indoor pool"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b53318891 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a kitchen"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1667505803 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a kitchenette"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1608354767 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with laundry facilities"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2083336183 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a lazy river"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1193596526 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " luxury hotels";}, one: function() { return number(d["0"]) + " luxury hotel";}, two: function() { return number(d["0"]) + " luxury hotels";}, few: function() { return number(d["0"]) + " luxury hotels";}, many: function() { return number(d["0"]) + " luxury hotels";}, other: function() { return number(d["0"]) + " luxury hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1083807314 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " non-smoking hotels";}, one: function() { return number(d["0"]) + " non-smoking hotel";}, two: function() { return number(d["0"]) + " non-smoking hotels";}, few: function() { return number(d["0"]) + " non-smoking hotels";}, many: function() { return number(d["0"]) + " non-smoking hotels";}, other: function() { return number(d["0"]) + " non-smoking hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2043056428 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " ocean view hotels";}, one: function() { return number(d["0"]) + " ocean view hotel";}, two: function() { return number(d["0"]) + " ocean view hotels";}, few: function() { return number(d["0"]) + " ocean view hotels";}, many: function() { return number(d["0"]) + " ocean view hotels";}, other: function() { return number(d["0"]) + " ocean view hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1442475639 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with an outdoor pool"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1191940649 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with parking"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1613725253 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " pet-friendly hotels";}, one: function() { return number(d["0"]) + " pet-friendly hotel";}, two: function() { return number(d["0"]) + " pet-friendly hotels";}, few: function() { return number(d["0"]) + " pet-friendly hotels";}, many: function() { return number(d["0"]) + " pet-friendly hotels";}, other: function() { return number(d["0"]) + " pet-friendly hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1899630945 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a pool"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1246309730 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " on the river"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1892543370 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " romantic hotels";}, one: function() { return number(d["0"]) + " romantic hotel";}, two: function() { return number(d["0"]) + " romantic hotels";}, few: function() { return number(d["0"]) + " romantic hotels";}, many: function() { return number(d["0"]) + " romantic hotels";}, other: function() { return number(d["0"]) + " romantic hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1101739115 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with room service"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1587942466 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " ski hotels";}, one: function() { return number(d["0"]) + " ski hotel";}, two: function() { return number(d["0"]) + " ski hotels";}, few: function() { return number(d["0"]) + " ski hotels";}, many: function() { return number(d["0"]) + " ski hotels";}, other: function() { return number(d["0"]) + " ski hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1588083733 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " spa hotels";}, one: function() { return number(d["0"]) + " spa hotel";}, two: function() { return number(d["0"]) + " spa hotels";}, few: function() { return number(d["0"]) + " spa hotels";}, many: function() { return number(d["0"]) + " spa hotels";}, other: function() { return number(d["0"]) + " spa hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1985387392 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with suites"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1564749874 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " waterpark hotels";}, one: function() { return number(d["0"]) + " waterpark hotel";}, two: function() { return number(d["0"]) + " waterpark hotels";}, few: function() { return number(d["0"]) + " waterpark hotels";}, many: function() { return number(d["0"]) + " waterpark hotels";}, other: function() { return number(d["0"]) + " waterpark hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b63387329 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with waterslides"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a65414341 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a wedding venue"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b2116391084 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a 1 star rating"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1228887403 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a 2 star rating"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b341383722 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a 3 star rating"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a546119959 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a 4 star rating"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1433623640 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }) + " with a 5 star rating"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a907207152 = messageFormatterFn((function(  ) {
  return function(d) { return "from <strong>" + d["0"] + "</strong>"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b54868661 = messageFormatterFn((function(  ) {
  return function(d) { return "from <span class=\"uitk-type-600 uitk-type-bold\">" + d["0"] + "</span>"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a542904626 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a692552074 = messageFormatterFn((function(  ) {
  return function(d) { return "per night/room"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b422171248 = messageFormatterFn((function(  ) {
  return function(d) { return "just found"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a281064374 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "found " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a643520204 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "found " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " days";}, one: function() { return number(d["0"]) + " day";}, two: function() { return number(d["0"]) + " days";}, few: function() { return number(d["0"]) + " days";}, many: function() { return number(d["0"]) + " days";}, other: function() { return number(d["0"]) + " days";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b925123827 = messageFormatterFn((function(  ) {
  return function(d) { return "roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a679118707 = messageFormatterFn((function(  ) {
  return function(d) { return "per day"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b82186539 = messageFormatterFn((function(  ) {
  return function(d) { return "flight + hotel per person"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a556807216 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1643663944 = messageFormatterFn((function(  ) {
  return function(d) { return "Flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a707024784 = messageFormatterFn((function(  ) {
  return function(d) { return "Cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a324961851 = messageFormatterFn((function(  ) {
  return function(d) { return "Vacations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1428952905 = messageFormatterFn((function(  ) {
  return function(d) { return "Vacation Rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1093854699 = messageFormatterFn((function(  ) {
  return function(d) { return "See properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b107471320 = messageFormatterFn((function(  ) {
  return function(d) { return "Read more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a822018156 = messageFormatterFn((function(  ) {
  return function(d) { return "Read less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1260508912 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular places to visit in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a463801543 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular places to visit in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b736285045 = messageFormatterFn((function(  ) {
  return function(d) { return "Top things to do in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a190570235 = messageFormatterFn((function(  ) {
  return function(d) { return "See all activities in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b907465459 = messageFormatterFn((function(  ) {
  return function(d) { return "Top landmarks in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1240962620 = messageFormatterFn((function(  ) {
  return function(d) { return "Top landmarks in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b650837565 = messageFormatterFn((function(  ) {
  return function(d) { return "See properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1831873947 = messageFormatterFn((function(  ) {
  return function(d) { return "Where to stay in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1435254229 = messageFormatterFn((function(  ) {
  return function(d) { return "Other areas in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b463040775 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1501254917 = messageFormatterFn((function(  ) {
  return function(d) { return "See properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1271660243 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotel + flight trips in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1692434178 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b818656473 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2104199881 = messageFormatterFn((function(  ) {
  return function(d) { return "See our Where To Stay guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2089878042 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " area reviews";}, one: function() { return d["1"] + " area review";}, two: function() { return d["1"] + " area reviews";}, few: function() { return d["1"] + " area reviews";}, many: function() { return d["1"] + " area reviews";}, other: function() { return d["1"] + " area reviews";} }); }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1947141892 = messageFormatterFn((function(  ) {
  return function(d) { return "Pictures of " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a29730843 = messageFormatterFn((function(  ) {
  return function(d) { return "Pictures of " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1515594398 = messageFormatterFn((function(  ) {
  return function(d) { return "Close thumbnails gallery"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b355505399 = messageFormatterFn((function(  ) {
  return function(d) { return "Browse nearby hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a874703750 = messageFormatterFn((function(  ) {
  return function(d) { return "Book a ticket"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b836196621 = messageFormatterFn((function(  ) {
  return function(d) { return "Find a room"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1101122993 = messageFormatterFn((function(  ) {
  return function(d) { return "Close map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1280108729 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1635431145 = messageFormatterFn((function(  ) {
  return function(d) { return "Close card"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1413313683 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a243613895 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore landmarks in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1085580784 = messageFormatterFn((function(  ) {
  return function(d) { return "Rooms from " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b803366625 = messageFormatterFn((function(  ) {
  return function(d) { return "Prices from " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a616190269 = messageFormatterFn((function(  ) {
  return function(d) { return "Picture of " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1508379952 = messageFormatterFn((function(  ) {
  return function(d) { return "Cropped from original"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1500531363 = messageFormatterFn((function(  ) {
  return function(d) { return "Breakfast included"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1192738849 = messageFormatterFn((function(  ) {
  return function(d) { return "Next"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1261438817 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1733335538 = messageFormatterFn((function(  ) {
  return function(d) { return "Show next image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1664635570 = messageFormatterFn((function(  ) {
  return function(d) { return "Show previous image"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a181051068 = messageFormatterFn((function(  ) {
  return function(d) { return "Close image gallery"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1288048315 = messageFormatterFn((function(  ) {
  return function(d) { return "Frequently asked questions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2051869933 = messageFormatterFn((function(  ) {
  return function(d) { return "How much is a hotel in " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a300786453 = messageFormatterFn((function(  ) {
  return function(d) { return "Month"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1250909282 = messageFormatterFn((function(  ) {
  return function(d) { return "Price"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1526860658 = messageFormatterFn((function(  ) {
  return function(d) { return "2 stars to 4 stars hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1448289916 = messageFormatterFn((function(  ) {
  return function(d) { return "Average price based on " + d["0"] + " bookings on " + d["1"] + " for 1 night / 2 adults."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b893251292 = messageFormatterFn((function(  ) {
  return function(d) { return "Average price based on " + d["0"] + " bookings of 2 stars to 4 stars hotels on " + d["1"] + " for 1 night / 2 adults."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1013890592 = messageFormatterFn((function(  ) {
  return function(d) { return "All prices are shown in " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1985011101 = messageFormatterFn((function(  ) {
  return function(d) { return "* No pricing data available"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1257700844 = messageFormatterFn((function(  ) {
  return function(d) { return "No data"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1040454212 = messageFormatterFn((function(  ) {
  return function(d) { return "View list"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b274323245 = messageFormatterFn((function(  ) {
  return function(d) { return "How much does it cost to stay in " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a543780054 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Last booking: " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " minutes";}, one: function() { return number(d["0"]) + " minute";}, two: function() { return number(d["0"]) + " minutes";}, few: function() { return number(d["0"]) + " minutes";}, many: function() { return number(d["0"]) + " minutes";}, other: function() { return number(d["0"]) + " minutes";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a518842886 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Last booking: " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1088665346 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b928164968 = messageFormatterFn((function(  ) {
  return function(d) { return "Dismiss"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1940470246 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1257780209 = messageFormatterFn((function(  ) {
  return function(d) { return "Other places like " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1057080082 = messageFormatterFn((function(  ) {
  return function(d) { return "Read travel guides and advice on visiting " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1445278675 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "See all " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " photos";}, one: function() { return number(d["0"]) + " photo";}, two: function() { return number(d["0"]) + " photos";}, few: function() { return number(d["0"]) + " photos";}, many: function() { return number(d["0"]) + " photos";}, other: function() { return number(d["0"]) + " photos";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1786264317 = messageFormatterFn((function(  ) {
  return function(d) { return "Overview"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b157085811 = messageFormatterFn((function(  ) {
  return function(d) { return "Video"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2144117005 = messageFormatterFn((function(  ) {
  return function(d) { return "Where to stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2011093117 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a214514191 = messageFormatterFn((function(  ) {
  return function(d) { return "Things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1473999507 = messageFormatterFn((function(  ) {
  return function(d) { return "Reviews"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b631180637 = messageFormatterFn((function(  ) {
  return function(d) { return "Blogs"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2004206270 = messageFormatterFn((function(  ) {
  return function(d) { return "Similar destinations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b311498387 = messageFormatterFn((function(  ) {
  return function(d) { return "Discover " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1352989571 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1824190445 = messageFormatterFn((function(  ) {
  return function(d) { return "Top places to visit"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1392091512 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular activities"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a455928572 = messageFormatterFn((function(  ) {
  return function(d) { return "Types of activities"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1545917580 = messageFormatterFn((function(  ) {
  return function(d) { return "Lowest nightly price found within the past 24 hours based on a 1 night stay for 2 adults. Prices and availability subject to change. Additional terms may apply."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b898472875 = messageFormatterFn((function(  ) {
  return function(d) { return "Check availability"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b333231515 = messageFormatterFn((function(  ) {
  return function(d) { return "Price increase from " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a974004361 = messageFormatterFn((function(  ) {
  return function(d) { return "Price decrease from " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1593864808 = messageFormatterFn((function(  ) {
  return function(d) { return "Sold out"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1519961312 = messageFormatterFn((function(  ) {
  return function(d) { return "See all recent searches"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1015891987 = messageFormatterFn((function(  ) {
  return function(d) { return "You could be seeing lower prices"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1420794017 = messageFormatterFn((function(  ) {
  return function(d) { return "Save an average of " + d["0"] + "% on thousands of hotels when you're signed in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a761913901 = messageFormatterFn((function(  ) {
  return function(d) { return "Save " + d["0"] + "% or more on thousands of hotels when you're signed in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b426683079 = messageFormatterFn((function(  ) {
  return function(d) { return "With member prices, you could save 10% or more right now on thousands of properties."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a753541081 = messageFormatterFn((function(  ) {
  return function(d) { return "Sign up, it's free"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a947121077 = messageFormatterFn((function(  ) {
  return function(d) { return "Sign in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a356302355 = messageFormatterFn((function(  ) {
  return function(d) { return "Not seeing what you're looking for?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b883763885 = messageFormatterFn((function(  ) {
  return function(d) { return "Try sorting with these options"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1050818179 = messageFormatterFn((function(  ) {
  return function(d) { return "January"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1319701497 = messageFormatterFn((function(  ) {
  return function(d) { return "February"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1581273892 = messageFormatterFn((function(  ) {
  return function(d) { return "March"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2065858335 = messageFormatterFn((function(  ) {
  return function(d) { return "April"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1489735042 = messageFormatterFn((function(  ) {
  return function(d) { return "May"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a551857063 = messageFormatterFn((function(  ) {
  return function(d) { return "June"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b452575363 = messageFormatterFn((function(  ) {
  return function(d) { return "July"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b343333400 = messageFormatterFn((function(  ) {
  return function(d) { return "August"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a968746602 = messageFormatterFn((function(  ) {
  return function(d) { return "September"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a973945081 = messageFormatterFn((function(  ) {
  return function(d) { return "October"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1232099945 = messageFormatterFn((function(  ) {
  return function(d) { return "November"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b56411510 = messageFormatterFn((function(  ) {
  return function(d) { return "December"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b435605174 = messageFormatterFn((function(  ) {
  return function(d) { return "Photo provided by " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1378057033 = messageFormatterFn((function(  ) {
  return function(d) { return "Stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b154267294 = messageFormatterFn((function(  ) {
  return function(d) { return "Properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a819352245 = messageFormatterFn((function(  ) {
  return function(d) { return "Vacation packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1997391401 = messageFormatterFn((function(  ) {
  return function(d) { return "Cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a446540255 = messageFormatterFn((function(  ) {
  return function(d) { return "Flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b827327877 = messageFormatterFn((function(  ) {
  return function(d) { return "Things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a186074524 = messageFormatterFn((function(  ) {
  return function(d) { return "Activities"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a447540803 = messageFormatterFn((function(  ) {
  return function(d) { return "Groups"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a299713436 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport transfers"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a151261099 = messageFormatterFn((function(  ) {
  return function(d) { return "Vacation rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a873025430 = messageFormatterFn((function(  ) {
  return function(d) { return "Vacation Rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b314230820 = messageFormatterFn((function(  ) {
  return function(d) { return "All-inclusive vacations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a842119940 = messageFormatterFn((function(  ) {
  return function(d) { return "Cruises"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a840487628 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " of " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1300325653 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a557506588 = messageFormatterFn((function(  ) {
  return function(d) { return "Luxury Hotels and Resorts Collection"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b730327350 = messageFormatterFn((function(  ) {
  return function(d) { return "Have a destination in mind?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1500795588 = messageFormatterFn((function(  ) {
  return function(d) { return "Refine your search"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1717678279 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a805586344 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular filters"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2049633092 = messageFormatterFn((function(  ) {
  return function(d) { return "Advanced options"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b762303706 = messageFormatterFn((function(  ) {
  return function(d) { return "Business-friendly"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1383738506 = messageFormatterFn((function(  ) {
  return function(d) { return "Family-friendly"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1819372673 = messageFormatterFn((function(  ) {
  return function(d) { return "Free cancellation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1722869782 = messageFormatterFn((function(  ) {
  return function(d) { return "Breakfast included"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a885107693 = messageFormatterFn((function(  ) {
  return function(d) { return "Verified traveller"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1704471628 = messageFormatterFn((function(  ) {
  return function(d) { return "Excellent"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1704470667 = messageFormatterFn((function(  ) {
  return function(d) { return "Good"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1704469706 = messageFormatterFn((function(  ) {
  return function(d) { return "Okay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1704468745 = messageFormatterFn((function(  ) {
  return function(d) { return "Disappointing"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1704467784 = messageFormatterFn((function(  ) {
  return function(d) { return "Terrible"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b649662096 = messageFormatterFn((function(  ) {
  return function(d) { return "Reviews of " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b488773937 = messageFormatterFn((function(  ) {
  return function(d) { return "Top destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a872325525 = messageFormatterFn((function(  ) {
  return function(d) { return "Guest rating"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1335107333 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " reviews";}, one: function() { return d["1"] + " review";}, two: function() { return d["1"] + " reviews";}, few: function() { return d["1"] + " reviews";}, many: function() { return d["1"] + " reviews";}, other: function() { return d["1"] + " reviews";} }); }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1200531458 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return "See " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + " reviews";}, one: function() { return d["1"] + " review";}, two: function() { return d["1"] + " reviews";}, few: function() { return "all " + d["1"] + " reviews";}, many: function() { return "all " + d["1"] + " reviews";}, other: function() { return "all " + d["1"] + " reviews";} }) + " of " + d["2"]; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b234967736 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b210109553 = messageFormatterFn((function(  ) {
  return function(d) { return "less than an hour ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a633918160 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return "one hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1700402062 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " days";}, one: function() { return "one day";}, two: function() { return number(d["0"]) + " days";}, few: function() { return number(d["0"]) + " days";}, many: function() { return number(d["0"]) + " days";}, other: function() { return number(d["0"]) + " days";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1156861728 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " weeks";}, one: function() { return "one week";}, two: function() { return number(d["0"]) + " weeks";}, few: function() { return number(d["0"]) + " weeks";}, many: function() { return number(d["0"]) + " weeks";}, other: function() { return number(d["0"]) + " weeks";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1258296086 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " months";}, one: function() { return "a month";}, two: function() { return number(d["0"]) + " months";}, few: function() { return number(d["0"]) + " months";}, many: function() { return number(d["0"]) + " months";}, other: function() { return number(d["0"]) + " months";} }) + " ago"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1218185252 = messageFormatterFn((function(  ) {
  return function(d) { return "a year ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1143743824 = messageFormatterFn((function(  ) {
  return function(d) { return "over a year ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1641865482 = messageFormatterFn((function(  ) {
  return function(d) { return "Plan your trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b106994522 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " by car"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a776777102 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + ", " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " minutes";}, one: function() { return number(d["1"]) + " minute";}, two: function() { return number(d["1"]) + " minutes";}, few: function() { return number(d["1"]) + " minutes";}, many: function() { return number(d["1"]) + " minutes";}, other: function() { return number(d["1"]) + " minutes";} }) + " by car"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a2048205558 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " minutes";}, one: function() { return number(d["0"]) + " minute";}, two: function() { return number(d["0"]) + " minutes";}, few: function() { return number(d["0"]) + " minutes";}, many: function() { return number(d["0"]) + " minutes";}, other: function() { return number(d["0"]) + " minutes";} }) + " by car"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a186869039 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "°C (avg.)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a186871922 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "°F (avg.)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b884396514 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/night average per room"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a830263340 = messageFormatterFn((function(  ) {
  return function(d) { return "Weekend getaways"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1082213717 = messageFormatterFn((function(  ) {
  return function(d) { return "Recommended destinations based on hotels you’ve viewed"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2078771701 = messageFormatterFn((function(  ) {
  return function(d) { return "Destinations for you"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a888509206 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in January"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1919457012 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in February"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b980325649 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in March"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1684151922 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in April"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1004570065 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in May"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1009218860 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in June"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1009178498 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in July"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a508100333 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in August"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1705001341 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in September"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a490634252 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in October"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1524045468 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in November"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1335230671 = messageFormatterFn((function(  ) {
  return function(d) { return "Two nights for two travellers near " + d["0"] + " in December"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a299176721 = messageFormatterFn((function(  ) {
  return function(d) { return "Search properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a513636656 = messageFormatterFn((function(  ) {
  return function(d) { return "Fly far, wander wide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1766520474 = messageFormatterFn((function(  ) {
  return function(d) { return "Take to the skies and discover your next adventure"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1471922250 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel stays, dream getaways"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a403959200 = messageFormatterFn((function(  ) {
  return function(d) { return "Find the perfect place to stay for your next trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1893277997 = messageFormatterFn((function(  ) {
  return function(d) { return "Build a package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b971183081 = messageFormatterFn((function(  ) {
  return function(d) { return "Book a flight, hotel or car together and maximize your savings"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1994606209 = messageFormatterFn((function(  ) {
  return function(d) { return "Search car rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1157532009 = messageFormatterFn((function(  ) {
  return function(d) { return "Search, compare and save with the car rental companies you trust"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1573347188 = messageFormatterFn((function(  ) {
  return function(d) { return "Cruise escapes, relaxing awaits"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2013851405 = messageFormatterFn((function(  ) {
  return function(d) { return "Things to do, everywhere you roam"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1954175113 = messageFormatterFn((function(  ) {
  return function(d) { return "Discover amazing experiences and activities for your next trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1495883162 = messageFormatterFn((function(  ) {
  return function(d) { return "Find and compare flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b584205916 = messageFormatterFn((function(  ) {
  return function(d) { return "Search, compare and book flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1990697302 = messageFormatterFn((function(  ) {
  return function(d) { return "Find and book a hotel for your next trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b814951197 = messageFormatterFn((function(  ) {
  return function(d) { return "Save with vacation packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b866446175 = messageFormatterFn((function(  ) {
  return function(d) { return "Create your own vacation package and save on your next trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a148551733 = messageFormatterFn((function(  ) {
  return function(d) { return "Find and compare car rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1008040205 = messageFormatterFn((function(  ) {
  return function(d) { return "Search, compare, and save with the biggest brands in car rental"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b592225026 = messageFormatterFn((function(  ) {
  return function(d) { return "Find and compare cruises"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2139189949 = messageFormatterFn((function(  ) {
  return function(d) { return "Find things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b86256255 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore and book activities for your next trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b15551687 = messageFormatterFn((function(  ) {
  return function(d) { return "Things to do in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a578961574 = messageFormatterFn((function(  ) {
  return function(d) { return "Car Hire"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a736894982 = messageFormatterFn((function(  ) {
  return function(d) { return "Search stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b797372172 = messageFormatterFn((function(  ) {
  return function(d) { return "Search flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b303616112 = messageFormatterFn((function(  ) {
  return function(d) { return "Search things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1538186328 = messageFormatterFn((function(  ) {
  return function(d) { return "Search vacation packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2078555850 = messageFormatterFn((function(  ) {
  return function(d) { return "Select two or more items to start building your trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b303323968 = messageFormatterFn((function(  ) {
  return function(d) { return "Search vacation rentals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b831086618 = messageFormatterFn((function(  ) {
  return function(d) { return "Search cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b355070951 = messageFormatterFn((function(  ) {
  return function(d) { return "Search cruises"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1948249707 = messageFormatterFn((function(  ) {
  return function(d) { return "More about " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1949117918 = messageFormatterFn((function(  ) {
  return function(d) { return "Recommended hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a380258005 = messageFormatterFn((function(  ) {
  return function(d) { return "Recommended hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a897054303 = messageFormatterFn((function(  ) {
  return function(d) { return "Stay here"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2115395042 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/5 (" + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " reviews";}, one: function() { return number(d["1"]) + " review";}, two: function() { return number(d["1"]) + " reviews";}, few: function() { return number(d["1"]) + " reviews";}, many: function() { return number(d["1"]) + " reviews";}, other: function() { return number(d["1"]) + " reviews";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1874880768 = messageFormatterFn((function(  ) {
  return function(d) { return "#" + d["0"] + " for " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a833784398 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination video for " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1467903382 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>" + d["0"] + "%</b> of travellers recommend"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a785570257 = messageFormatterFn((function(  ) {
  return function(d) { return "Per adult"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1409281191 = messageFormatterFn((function(  ) {
  return function(d) { return "Still deciding where to go?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a236469508 = messageFormatterFn((function(  ) {
  return function(d) { return "Beach"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1783828551 = messageFormatterFn((function(  ) {
  return function(d) { return "Family"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b915339258 = messageFormatterFn((function(  ) {
  return function(d) { return "Romantic"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1787397242 = messageFormatterFn((function(  ) {
  return function(d) { return "Mountain"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a586030964 = messageFormatterFn((function(  ) {
  return function(d) { return "Historic"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b6074747 = messageFormatterFn((function(  ) {
  return function(d) { return "Spa"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b532399177 = messageFormatterFn((function(  ) {
  return function(d) { return "Golf"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1749499914 = messageFormatterFn((function(  ) {
  return function(d) { return "Casino"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1793306274 = messageFormatterFn((function(  ) {
  return function(d) { return "Waterpark"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1452750569 = messageFormatterFn((function(  ) {
  return function(d) { return "Hot tub"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b274641679 = messageFormatterFn((function(  ) {
  return function(d) { return "Pool"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2137163976 = messageFormatterFn((function(  ) {
  return function(d) { return "Close"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b85968657 = messageFormatterFn((function(  ) {
  return function(d) { return "Your upcoming trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1664021208 = messageFormatterFn((function(  ) {
  return function(d) { return "Your " + d["0"] + " trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1608325824 = messageFormatterFn((function(  ) {
  return function(d) { return "Savings unlocked!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1467621148 = messageFormatterFn((function(  ) {
  return function(d) { return "View hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1608570918 = messageFormatterFn((function(  ) {
  return function(d) { return "Car savings unlocked!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b242461046 = messageFormatterFn((function(  ) {
  return function(d) { return "You unlocked up to " + d["0"] + "% off cars because you booked on Expedia."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1460023234 = messageFormatterFn((function(  ) {
  return function(d) { return "View cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a229642950 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel savings unlocked!"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a23927082 = messageFormatterFn((function(  ) {
  return function(d) { return "You unlocked up to " + d["0"] + "% off hotels because you booked on Expedia."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b34349107 = messageFormatterFn((function(  ) {
  return function(d) { return "<b>" + d["0"] + "</b> (" + d["1"] + ") <b>- " + d["2"] + "</b> (" + d["3"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1371215067 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " (" + d["1"] + ") - " + d["2"] + " (" + d["3"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a862022427 = messageFormatterFn((function(  ) {
  return function(d) { return "Terms and conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2035773890 = messageFormatterFn((function(  ) {
  return function(d) { return "Price disclaimer"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1788576348 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1289288647 = messageFormatterFn((function(  ) {
  return function(d) { return "Price was " + d["0"] + ", price is now " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1979883959 = messageFormatterFn((function(  ) {
  return function(d) { return "Offers"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b899604007 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, this campaign has ended"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1060764945 = messageFormatterFn((function(  ) {
  return function(d) { return "Please enjoy browsing our other travel deals and recommendations below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a363288048 = messageFormatterFn((function(  ) {
  return function(d) { return "Families like:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a132565206 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers like:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b467554221 = messageFormatterFn((function(  ) {
  return function(d) { return "Great for families"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1141513173 = messageFormatterFn((function(  ) {
  return function(d) { return "Great for spa weekends"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b307939621 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers say..."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1735042337 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a929356376 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter by"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b635934338 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort & filter"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a359661672 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a321840556 = messageFormatterFn((function(  ) {
  return function(d) { return "See less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a713785339 = messageFormatterFn((function(  ) {
  return function(d) { return "Show less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1902814287 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b403615698 = messageFormatterFn((function(  ) {
  return function(d) { return "Get rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b231208964 = messageFormatterFn((function(  ) {
  return function(d) { return "Keep planning"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b774578840 = messageFormatterFn((function(  ) {
  return function(d) { return "per traveller"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1724326262 = messageFormatterFn((function(  ) {
  return function(d) { return "per person"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1383858418 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Explore similar " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + "-star";}, one: function() { return number(d["0"]) + "-star";}, two: function() { return number(d["0"]) + "-star";}, few: function() { return number(d["0"]) + "-star";}, many: function() { return number(d["0"]) + "-star";}, other: function() { return number(d["0"]) + "-star";} }) + " hotels"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1758089608 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Many " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + "-star";}, one: function() { return number(d["0"]) + "-star";}, two: function() { return number(d["0"]) + "-star";}, few: function() { return number(d["0"]) + "-star";}, many: function() { return number(d["0"]) + "-star";}, other: function() { return number(d["0"]) + "-star";} }) + " hotels have the same amenities as " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + "-star";}, one: function() { return number(d["1"]) + "-star";}, two: function() { return number(d["1"]) + "-star";}, few: function() { return number(d["1"]) + "-star";}, many: function() { return number(d["1"]) + "-star";}, other: function() { return number(d["1"]) + "-star";} }) + " hotels. See all " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + "-star";}, one: function() { return number(d["0"]) + "-star";}, two: function() { return number(d["0"]) + "-star";}, few: function() { return number(d["0"]) + "-star";}, many: function() { return number(d["0"]) + "-star";}, other: function() { return number(d["0"]) + "-star";} }) + " hotels in " + d["2"] + "."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1555870473 = messageFormatterFn((function(  ) {
  return function(d) { return "Still don't see what you're looking for?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1702985153 = messageFormatterFn((function(  ) {
  return function(d) { return "See all properties in " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b830681437 = messageFormatterFn((function(  ) {
  return function(d) { return "You can also use these popular filters to refine your search."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1524800253 = messageFormatterFn((function( plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return d["1"] + "-star";}, one: function() { return d["1"] + "-star";}, two: function() { return d["1"] + "-star";}, few: function() { return d["1"] + "-star";}, many: function() { return d["1"] + "-star";}, other: function() { return d["1"] + "-star";} }) + " property"; }
})(messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a142515821 = messageFormatterFn((function(  ) {
  return function(d) { return "Non-stop roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1441350048 = messageFormatterFn((function(  ) {
  return function(d) { return "Roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1914703492 = messageFormatterFn((function(  ) {
  return function(d) { return "Non-stop"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1449821976 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " night";}, one: function() { return number(d["0"]) + " night";}, two: function() { return number(d["0"]) + " night";}, few: function() { return number(d["0"]) + " night";}, many: function() { return number(d["0"]) + " night";}, other: function() { return number(d["0"]) + " night";} }) + " stay"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1736974800 = messageFormatterFn((function(  ) {
  return function(d) { return "Shop for this Flight and Hotel package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b266424820 = messageFormatterFn((function(  ) {
  return function(d) { return "Includes " + d["0"] + " and " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a863828454 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " night";}, one: function() { return number(d["0"]) + " night";}, two: function() { return number(d["0"]) + " night";}, few: function() { return number(d["0"]) + " night";}, many: function() { return number(d["0"]) + " night";}, other: function() { return number(d["0"]) + " night";} }) + " stay"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a995631102 = messageFormatterFn((function(  ) {
  return function(d) { return "Read disclaimer"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a857152740 = messageFormatterFn((function(  ) {
  return function(d) { return "Close"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2097261584 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " (" + d["1"] + ") to " + d["2"] + " (" + d["3"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1754539433 = messageFormatterFn((function(  ) {
  return function(d) { return "Save " + d["0"] + "% on your flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a442203739 = messageFormatterFn((function(  ) {
  return function(d) { return "Save " + d["0"] + "% on your car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b827136245 = messageFormatterFn((function(  ) {
  return function(d) { return "Price was " + d["0"] + ", price is now " + d["1"] + " per person"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1737029577 = messageFormatterFn((function(  ) {
  return function(d) { return "Shop for this Hotel and Car package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1429300984 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Compact rental car and " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + "-night";}, one: function() { return number(d["0"]) + "-night";}, two: function() { return number(d["0"]) + "-night";}, few: function() { return number(d["0"]) + "-night";}, many: function() { return number(d["0"]) + "-night";}, other: function() { return number(d["0"]) + "-night";} }) + " stay"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1007520171 = messageFormatterFn((function(  ) {
  return function(d) { return "Click-to-Cancel: Your hotel qualifies for free cancellation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b524557481 = messageFormatterFn((function(  ) {
  return function(d) { return "Click-to-Cancel: Your flight qualifies for free cancellation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1423276343 = messageFormatterFn((function(  ) {
  return function(d) { return "Itinerary " + "#" + " " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1450506247 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll let you cancel your booking for free prior to checking in and process your refund through your original form of payment. By clicking the button below, we will automatically cancel your reservation. Please remember, you do not need to call to confirm this cancellation—we've got you covered. If you would like to keep your booking or have already cancelled previously, just close out of this page without clicking the button below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b866052187 = messageFormatterFn((function(  ) {
  return function(d) { return "Your airline will let you cancel your flight for free up to 24 hours before you travel and will give you a credit to use for future flights with them. By clicking the button below, we will automatically cancel your flight. Please remember, you do not need to call to confirm this cancellation—we've got you covered. If you would like to keep your booking or have already cancelled previously, just close out of this page without clicking the button below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1375233405 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your hotel reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1472825046 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your reservation at " + d["0"] + " by " + d["1"] + " and get a full refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1472826007 = messageFormatterFn((function(  ) {
  return function(d) { return "If you cancel, a 100% refund will be credited to your original form of payment. It may take up to 30 days for you to receive your refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1472826968 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want to cancel your reservation?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a233662642 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my reservation, I confirm that I want to cancel and that I will not be charged a cancellation fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1823915095 = messageFormatterFn((function(  ) {
  return function(d) { return "Read the terms and conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1887366405 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, cancel my reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1817819488 = messageFormatterFn((function(  ) {
  return function(d) { return "No, don’t cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b37770911 = messageFormatterFn((function(  ) {
  return function(d) { return "Terms and conditions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1324367896 = messageFormatterFn((function(  ) {
  return function(d) { return "You may cancel your prepaid hotel reservation and you will not be charged any cancellation fee indicated in the rules and restrictions for the hotel reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1324368857 = messageFormatterFn((function(  ) {
  return function(d) { return "If you do not cancel your reservation before the cancellation date provided in this message, you will be subject to a charge equal to applicable nightly rates, tax recovery charges, and service fees."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1324369818 = messageFormatterFn((function(  ) {
  return function(d) { return "Credit may take up to 30 days to appear on your statement, depending upon the issuing card bank."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a164188736 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2017747726 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send a confirmation to " + d["0"] + " within the next 14 days. It may take up to 30 days for you to receive your refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1250206044 = messageFormatterFn((function(  ) {
  return function(d) { return "Your reservation is still active"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a630473074 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you want to keep your reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1394814957 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b383075514 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flight and we’ll give you an airline credit in the amount of the original ticket price to use for a future flight with the same airline."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a914802938 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flight by " + d["0"] + ", and the airline will give you an airline credit in the amount of the original ticket price. You can use this credit for a future flight with the same airline within 24 months of the original purchase date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b383074553 = messageFormatterFn((function(  ) {
  return function(d) { return "If the airline has already cancelled your reservation, you can ignore this message."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b383073592 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want to cancel your flight?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a214081090 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my flight, I confirm that I want to cancel and that I will not be charged a cancellation fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a245432459 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, cancel my flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a242260752 = messageFormatterFn((function(  ) {
  return function(d) { return "No, don’t cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1543820240 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a885430441 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send a confirmation email to " + d["0"] + " in the coming weeks. We may not be able to respond before your departure date. However, rest assured that your cancellation will be processed. No further action is required on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a885431402 = messageFormatterFn((function(  ) {
  return function(d) { return "You’ll receive an airline credit in the amount of the original ticket price to use for a future flight with the same airline."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a885432363 = messageFormatterFn((function(  ) {
  return function(d) { return "Due to the unprecedented volume of travel disruptions, your airline credit may take up to 30 days to process. You will receive another email when your airline credit is available. This email will contain the amount of the airline credit, the expiration date, and how to use it for a future flight."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a442049300 = messageFormatterFn((function(  ) {
  return function(d) { return "We didn’t change your reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a23444962 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you don’t want us to cancel your flight."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a108073469 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel or keep your hotel reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1730293348 = messageFormatterFn((function(  ) {
  return function(d) { return "We've worked closely with our travel partners to offer you a voucher in the form of a coupon if you decide to cancel your non-refundable reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1730292387 = messageFormatterFn((function(  ) {
  return function(d) { return "You must cancel by " + d["0"] + " to receive a coupon. This coupon will be equal to the full amount of the original purchase price. Just let us know if you want to cancel or keep your reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a521026933 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel my reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1438104218 = messageFormatterFn((function(  ) {
  return function(d) { return "Keep my reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b150521542 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your reservation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b857064577 = messageFormatterFn((function(  ) {
  return function(d) { return "You'll see the update in your itinerary within the next 72 hours. Please note: Your itinerary will not reflect the coupon amount."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b857063616 = messageFormatterFn((function(  ) {
  return function(d) { return "Due to the unprecedented volume of travel disruptions, your coupon may take up to 30 days to arrive. You won't receive an email until your coupon is ready. No further action is necessary on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b857062655 = messageFormatterFn((function(  ) {
  return function(d) { return "The coupon is valid for one year from the date of issue for a new reservation at the same property."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a395543402 = messageFormatterFn((function(  ) {
  return function(d) { return "Your reservation is still active"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b631654088 = messageFormatterFn((function(  ) {
  return function(d) { return "Thanks for confirming that you want to keep your reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1319866147 = messageFormatterFn((function(  ) {
  return function(d) { return "We're sorry"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2003874004 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a833698509 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flights and we’ll give you airline credits in the amount of the original ticket prices to use for future flights with the same airlines. If you choose to cancel, we’ll cancel all of the following flights:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1504624273 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your flights and we’ll give you airline credits in the amount of the original ticket prices to use for future flights with the same airline. If you choose to cancel, we’ll cancel all of the following flights:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a833699470 = messageFormatterFn((function(  ) {
  return function(d) { return "If the airlines have already cancelled your reservations, you can ignore this message."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1504625234 = messageFormatterFn((function(  ) {
  return function(d) { return "If the airline has already cancelled your reservations, you can ignore this message."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a833700431 = messageFormatterFn((function(  ) {
  return function(d) { return "Do you want to cancel your flights?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a833701392 = messageFormatterFn((function(  ) {
  return function(d) { return "Please note: We will cancel all of the above flights at the same time. We can’t cancel each flight individually."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b394977957 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my flights, I confirm that I want to cancel all of my flights and that I will not be charged a cancellation fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1067693276 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, cancel my flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1069938775 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a118791024 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send " + d["0"] + " confirmation emails (one for each leg of your flight) to " + d["1"] + " in the coming weeks. We may not be able to respond before your departure date. However, rest assured that your cancellation will be processed. No further action is required on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a118791985 = messageFormatterFn((function(  ) {
  return function(d) { return "You’ll receive airline credits in the amount of the original ticket prices to use for future flights with the same airlines."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a83863375 = messageFormatterFn((function(  ) {
  return function(d) { return "You’ll receive airline credits in the amount of the original ticket prices to use for future flights with the same airline."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a118792946 = messageFormatterFn((function(  ) {
  return function(d) { return "Due to the unprecedented volume of travel disruptions, your airline credits may take up to 30 days to process. You will receive " + d["0"] + " additional emails when your airline credits are available. These emails will contain the amount of the airline credits, the expiration dates, and how to use them for future flights."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a575928517 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": " + d["1"] + " - " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1077558598 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your " + d["0"] + " flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1891144435 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your " + d["0"] + " flight and we’ll give you an airline credit in the amount of the original ticket price to use for a future flight with " + d["0"] + ". If you choose to cancel, we’ll cancel the following flight:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1891145396 = messageFormatterFn((function(  ) {
  return function(d) { return "Unfortunately, we can’t cancel the following flight. You’ll have to contact the airline to cancel this flight."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1891146357 = messageFormatterFn((function(  ) {
  return function(d) { return "By selecting Yes, cancel my " + d["0"] + " flight, I confirm that I want to cancel my " + d["0"] + " flight and that I will not be charged a cancellation fee. I also understand that I must cancel my " + d["1"] + " flight through the airline."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1370579906 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, cancel my " + d["0"] + " flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b880359957 = messageFormatterFn((function(  ) {
  return function(d) { return "No, don’t cancel my " + d["0"] + " flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1021892413 = messageFormatterFn((function(  ) {
  return function(d) { return "We have cancelled your " + d["0"] + " flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1146003606 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ll send a confirmation email to " + d["0"] + " in the coming weeks. We may not be able to respond before your departure date. However, rest assured that your cancellation will be processed. No further action is required on your part."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1146004567 = messageFormatterFn((function(  ) {
  return function(d) { return "You’ll receive an airline credit in the amount of the original " + d["0"] + " ticket price to use for future flights with " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1146005528 = messageFormatterFn((function(  ) {
  return function(d) { return "Due to the unprecedented volume of travel disruptions, your airline credits may take up to 30 days to process. You will receive an additional email when your airline credit is available. This email will contain the amount of the airline credit, the expiration date, and how to use it for a future flight."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b616404933 = messageFormatterFn((function(  ) {
  return function(d) { return "Link to the " + d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b591627784 = messageFormatterFn((function(  ) {
  return function(d) { return "Link to the " + d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a954350203 = messageFormatterFn((function(  ) {
  return function(d) { return "See all available trips from " + d["0"] + " to " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a512574587 = messageFormatterFn((function(  ) {
  return function(d) { return "View all trips"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1764471760 = messageFormatterFn((function(  ) {
  return function(d) { return "Apply Now"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1317703777 = messageFormatterFn((function(  ) {
  return function(d) { return "See the details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1658917093 = messageFormatterFn((function(  ) {
  return function(d) { return "Chart for illustrative purposes only"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1422746014 = messageFormatterFn((function(  ) {
  return function(d) { return "Show details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1557675278 = messageFormatterFn((function(  ) {
  return function(d) { return "Show review"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1253240469 = messageFormatterFn((function(  ) {
  return function(d) { return "Select"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b532325955 = messageFormatterFn((function(  ) {
  return function(d) { return "Hide details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1323095469 = messageFormatterFn((function(  ) {
  return function(d) { return "Hide review"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1450671772 = messageFormatterFn((function(  ) {
  return function(d) { return "Opted In"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2026978701 = messageFormatterFn((function(  ) {
  return function(d) { return "Opted Out"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1814508055 = messageFormatterFn((function(  ) {
  return function(d) { return "You can also manage your cookie preferences at any time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a937780187 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1468626310 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1266057128 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b809628787 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b363838967 = messageFormatterFn((function(  ) {
  return function(d) { return "Origin airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1178463569 = messageFormatterFn((function(  ) {
  return function(d) { return "Roundtrip price"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b518867246 = messageFormatterFn((function(  ) {
  return function(d) { return "Distance"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b392400007 = messageFormatterFn((function(  ) {
  return function(d) { return "Origin city name"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a734705781 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination city name"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1667404596 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination airport IATA code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a989843760 = messageFormatterFn((function(  ) {
  return function(d) { return "Origin airport IATA code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1975730306 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular airline"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b612677133 = messageFormatterFn((function(  ) {
  return function(d) { return "Average flight time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2128843672 = messageFormatterFn((function(  ) {
  return function(d) { return "Number of airlines serving"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1153971953 = messageFormatterFn((function(  ) {
  return function(d) { return "Number of flight options"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a624244646 = messageFormatterFn((function(  ) {
  return function(d) { return "Airlines serving"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1658950769 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"] + " route information"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a647323417 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + " " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " mins";}, one: function() { return number(d["1"]) + " min";}, two: function() { return number(d["1"]) + " mins";}, few: function() { return number(d["1"]) + " mins";}, many: function() { return number(d["1"]) + " mins";}, other: function() { return number(d["1"]) + " mins";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b228268184 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return number(d["0"]) + " hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b170419784 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " mins";}, one: function() { return number(d["0"]) + " min";}, two: function() { return number(d["0"]) + " mins";}, few: function() { return number(d["0"]) + " mins";}, many: function() { return number(d["0"]) + " mins";}, other: function() { return number(d["0"]) + " mins";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b671144719 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a13763247 = messageFormatterFn((function(  ) {
  return function(d) { return "Country"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b368885233 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport name"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1304135592 = messageFormatterFn((function(  ) {
  return function(d) { return "Number of flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a885866355 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Airports"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1899591723 = messageFormatterFn((function(  ) {
  return function(d) { return "Hop on a(n) " + d["0"] + " flight today by flying to many destinations out of these domestic and international airports:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1599756485 = messageFormatterFn((function(  ) {
  return function(d) { return "Carrier"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a420943005 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1120045122 = messageFormatterFn((function(  ) {
  return function(d) { return "Depart"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1532923573 = messageFormatterFn((function(  ) {
  return function(d) { return "Departs"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b884217665 = messageFormatterFn((function(  ) {
  return function(d) { return "Arrive"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1441224040 = messageFormatterFn((function(  ) {
  return function(d) { return "Arrives"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a56906420 = messageFormatterFn((function(  ) {
  return function(d) { return "Stops"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1022974782 = messageFormatterFn((function(  ) {
  return function(d) { return "Check Fare"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a676494510 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminal"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2018492671 = messageFormatterFn((function(  ) {
  return function(d) { return "Gate"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1367985975 = messageFormatterFn((function(  ) {
  return function(d) { return "Data not available at this time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2063780845 = messageFormatterFn((function(  ) {
  return function(d) { return "At this time, we do not have a record for this flight on this date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b984300697 = messageFormatterFn((function(  ) {
  return function(d) { return "Please try again later"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1771822841 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "TOTAL TIME " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " h";}, one: function() { return number(d["0"]) + " h";}, two: function() { return number(d["0"]) + " h";}, few: function() { return number(d["0"]) + " h";}, many: function() { return number(d["0"]) + " h";}, other: function() { return number(d["0"]) + " h";} }) + " " + plural(d["1"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["1"]) + " m";}, one: function() { return number(d["1"]) + " m";}, two: function() { return number(d["1"]) + " m";}, few: function() { return number(d["1"]) + " m";}, many: function() { return number(d["1"]) + " m";}, other: function() { return number(d["1"]) + " m";} }) + "  | TOTAL DISTANCE: " + d["2"] + " " + d["3"]; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1698297655 = messageFormatterFn((function(  ) {
  return function(d) { return "Travel searches are powered by Expedia."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a377723512 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up location"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1157833564 = messageFormatterFn((function(  ) {
  return function(d) { return "Don't see what you're looking for?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1809284970 = messageFormatterFn((function(  ) {
  return function(d) { return "See all car rentals in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2131528116 = messageFormatterFn((function(  ) {
  return function(d) { return "View all cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a490981884 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Lowest prices found within the past " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " days";}, one: function() { return "day";}, two: function() { return number(d["0"]) + " days";}, few: function() { return number(d["0"]) + " days";}, many: function() { return number(d["0"]) + " days";}, other: function() { return number(d["0"]) + " days";} }) + ". Prices and availability subject to change. Additional terms may apply."; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1987744288 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Lowest prices found within the past " + plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hours";}, one: function() { return "hour";}, two: function() { return number(d["0"]) + " hours";}, few: function() { return number(d["0"]) + " hours";}, many: function() { return number(d["0"]) + " hours";}, other: function() { return number(d["0"]) + " hours";} }) + ". Prices and availability subject to change. Additional terms may apply. "; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b750181541 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " people";}, one: function() { return number(d["0"]) + " person";}, two: function() { return number(d["0"]) + " people";}, few: function() { return number(d["0"]) + " people";}, many: function() { return number(d["0"]) + " people";}, other: function() { return number(d["0"]) + " people";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1634478165 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " or similar"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a840243605 = messageFormatterFn((function(  ) {
  return function(d) { return "per day"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1953811484 = messageFormatterFn((function(  ) {
  return function(d) { return "total"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a989438280 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Airport (" + d["1"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2123501660 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + ", " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1978495539 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1963825738 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"] + " from " + d["2"] + " city centre"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1578558120 = messageFormatterFn((function(  ) {
  return function(d) { return "Unlimited mileage"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a329035473 = messageFormatterFn((function(  ) {
  return function(d) { return "Limited mileage"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1145105575 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free miles";}, one: function() { return number(d["0"]) + " free mile";}, two: function() { return number(d["0"]) + " free miles";}, few: function() { return number(d["0"]) + " free miles";}, many: function() { return number(d["0"]) + " free miles";}, other: function() { return number(d["0"]) + " free miles";} }) + "/day"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a608038175 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free kilometres";}, one: function() { return number(d["0"]) + " free kilometre";}, two: function() { return number(d["0"]) + " free kilometres";}, few: function() { return number(d["0"]) + " free kilometres";}, many: function() { return number(d["0"]) + " free kilometres";}, other: function() { return number(d["0"]) + " free kilometres";} }) + "/day"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a1049392727 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free miles";}, one: function() { return number(d["0"]) + " free mile";}, two: function() { return number(d["0"]) + " free miles";}, few: function() { return number(d["0"]) + " free miles";}, many: function() { return number(d["0"]) + " free miles";}, other: function() { return number(d["0"]) + " free miles";} }) + "/week"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b437725871 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free kilometres";}, one: function() { return number(d["0"]) + " free kilometre";}, two: function() { return number(d["0"]) + " free kilometres";}, few: function() { return number(d["0"]) + " free kilometres";}, many: function() { return number(d["0"]) + " free kilometres";}, other: function() { return number(d["0"]) + " free kilometres";} }) + "/week"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1034392819 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free miles";}, one: function() { return number(d["0"]) + " free mile";}, two: function() { return number(d["0"]) + " free miles";}, few: function() { return number(d["0"]) + " free miles";}, many: function() { return number(d["0"]) + " free miles";}, other: function() { return number(d["0"]) + " free miles";} }) + "/month"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a109570899 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free kilometres";}, one: function() { return number(d["0"]) + " free kilometre";}, two: function() { return number(d["0"]) + " free kilometres";}, few: function() { return number(d["0"]) + " free kilometres";}, many: function() { return number(d["0"]) + " free kilometres";}, other: function() { return number(d["0"]) + " free kilometres";} }) + "/month"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a991017915 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free miles";}, one: function() { return number(d["0"]) + " free mile";}, two: function() { return number(d["0"]) + " free miles";}, few: function() { return number(d["0"]) + " free miles";}, many: function() { return number(d["0"]) + " free miles";}, other: function() { return number(d["0"]) + " free miles";} }) + "/total"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b1307733707 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " free kilometres";}, one: function() { return number(d["0"]) + " free kilometre";}, two: function() { return number(d["0"]) + " free kilometres";}, few: function() { return number(d["0"]) + " free kilometres";}, many: function() { return number(d["0"]) + " free kilometres";}, other: function() { return number(d["0"]) + " free kilometres";} }) + "/total"; }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a939281583 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1350630267 = messageFormatterFn((function(  ) {
  return function(d) { return "When is the best time to visit " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b406329828 = messageFormatterFn((function(  ) {
  return function(d) { return "When is the best time to visit " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a615689565 = messageFormatterFn((function(  ) {
  return function(d) { return "Not sure when to go to " + d["0"] + "? Check out price trends for the year below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a718491898 = messageFormatterFn((function(  ) {
  return function(d) { return "Not sure when to go to " + d["0"] + "? Check out price trends for the year below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a972645961 = messageFormatterFn((function(  ) {
  return function(d) { return "More details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b659010363 = messageFormatterFn((function(  ) {
  return function(d) { return "Price Trend Illustration"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1956161617 = messageFormatterFn((function(  ) {
  return function(d) { return "Show all"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1849325052 = messageFormatterFn((function(  ) {
  return function(d) { return "Hide all"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2128699049 = messageFormatterFn((function(  ) {
  return function(d) { return "Share"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1525964332 = messageFormatterFn((function(  ) {
  return function(d) { return "Email"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b242723245 = messageFormatterFn((function(  ) {
  return function(d) { return "Copy link"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a796609618 = messageFormatterFn((function(  ) {
  return function(d) { return "Share on " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b571377792 = messageFormatterFn((function(  ) {
  return function(d) { return "Share by email"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a706106350 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, something went wrong on our end. Please try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2081816628 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b246984888 = messageFormatterFn((function(  ) {
  return function(d) { return "Find your perfect somewhere™"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1256664345 = messageFormatterFn((function(  ) {
  return function(d) { return "Similar properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1700908917 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " hotels";}, one: function() { return number(d["0"]) + " hotel";}, two: function() { return number(d["0"]) + " hotels";}, few: function() { return number(d["0"]) + " hotels";}, many: function() { return number(d["0"]) + " hotels";}, other: function() { return number(d["0"]) + " hotels";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.b691195338 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-CA"], { zero: function() { return number(d["0"]) + " activities";}, one: function() { return number(d["0"]) + " activity";}, two: function() { return number(d["0"]) + " activities";}, few: function() { return number(d["0"]) + " activities";}, many: function() { return number(d["0"]) + " activities";}, other: function() { return number(d["0"]) + " activities";} }); }
})(messageFormat.number, messageFormat.plural, {"en-CA": Globalize("en-CA").pluralGenerator()}), Globalize("en-CA").pluralGenerator({}));
Globalize.a245466010 = messageFormatterFn((function(  ) {
  return function(d) { return "Map is currently unavailable"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a492980189 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Reviews"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1843421219 = messageFormatterFn((function(  ) {
  return function(d) { return "Over 14 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1448626014 = messageFormatterFn((function(  ) {
  return function(d) { return "When is the best time to visit " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2032091294 = messageFormatterFn((function(  ) {
  return function(d) { return "Your flight unlocks savings on hotels, cars and activities."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b751171449 = messageFormatterFn((function(  ) {
  return function(d) { return "Departing"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1649369747 = messageFormatterFn((function(  ) {
  return function(d) { return "found 1 minute ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a616380417 = messageFormatterFn((function(  ) {
  return function(d) { return "Build a package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1699319768 = messageFormatterFn((function(  ) {
  return function(d) { return "Something went wrong"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1436285721 = messageFormatterFn((function(  ) {
  return function(d) { return "Link to the " + d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1107104141 = messageFormatterFn((function(  ) {
  return function(d) { return "Special check-in instructions"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a393546613 = messageFormatterFn((function(  ) {
  return function(d) { return "How are prices calculated?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1447816828 = messageFormatterFn((function(  ) {
  return function(d) { return "Your package deal unlocks savings on hotels and activities."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b748441836 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by accommodations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1255838213 = messageFormatterFn((function(  ) {
  return function(d) { return "Multilingual staff"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1156130403 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore places to stay in each destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a643786653 = messageFormatterFn((function(  ) {
  return function(d) { return "Unlimited mileage"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a277067409 = messageFormatterFn((function(  ) {
  return function(d) { return "Infant " + d["0"] + " age, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1529255385 = messageFormatterFn((function(  ) {
  return function(d) { return "Guests"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a493157314 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up and drop-off"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1752087444 = messageFormatterFn((function(  ) {
  return function(d) { return "One way"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2122063219 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b733923393 = messageFormatterFn((function(  ) {
  return function(d) { return "City or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a248250961 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel your trip and we'll process your cancellation as outlined in your itinerary " + "#" + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1720448851 = messageFormatterFn((function(  ) {
  return function(d) { return "Golf course on site"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2123844230 = messageFormatterFn((function(  ) {
  return function(d) { return "We’ve worked closely with our travel partners to offer you a voucher in the form of a coupon if you decide to cancel your non-refundable reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1507161540 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more properties"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1014356949 = messageFormatterFn((function(  ) {
  return function(d) { return "Pet-friendly"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1220320483 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia-verified review"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a96516157 = messageFormatterFn((function(  ) {
  return function(d) { return "Trover photo \"" + d["0"] + "\" by " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1646584467 = messageFormatterFn((function(  ) {
  return function(d) { return "found 1 day ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1580170307 = messageFormatterFn((function(  ) {
  return function(d) { return "We don't recognize that phone number. Please double check the phone number and try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1835306 = messageFormatterFn((function(  ) {
  return function(d) { return "Great for beach vacations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346148168 = messageFormatterFn((function(  ) {
  return function(d) { return "7."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1852221142 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes, I am confirming I wish to cancel my upcoming booking with " + d["0"] + ". I understand this cancellation is free, and will result in the removal of my reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1132952825 = messageFormatterFn((function(  ) {
  return function(d) { return "Exceptional"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1636637228 = messageFormatterFn((function(  ) {
  return function(d) { return "1 stop"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1866922582 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport Transportation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a971947541 = messageFormatterFn((function(  ) {
  return function(d) { return "Free breakfast"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b532068615 = messageFormatterFn((function(  ) {
  return function(d) { return "Duration"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2124018402 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346145285 = messageFormatterFn((function(  ) {
  return function(d) { return "4."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1989764106 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1818888014 = messageFormatterFn((function(  ) {
  return function(d) { return "Drivers under " + d["0"] + " or over " + d["1"] + " might be required to pay an extra fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1124636810 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous searches"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2047229198 = messageFormatterFn((function(  ) {
  return function(d) { return "See more areas"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b44160805 = messageFormatterFn((function(  ) {
  return function(d) { return "Trips starts"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a121292374 = messageFormatterFn((function(  ) {
  return function(d) { return "Limited mileage"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a589733228 = messageFormatterFn((function(  ) {
  return function(d) { return "Given the rapidly changing circumstances, please check back when you are within 7 days of your travel date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1539918081 = messageFormatterFn((function(  ) {
  return function(d) { return "Looking for sports, concerts or theatre events?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1513868499 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b984496435 = messageFormatterFn((function(  ) {
  return function(d) { return "Please try your search again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1949616337 = messageFormatterFn((function(  ) {
  return function(d) { return "there is 1 result"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2137207190 = messageFormatterFn((function(  ) {
  return function(d) { return "- " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a145346394 = messageFormatterFn((function(  ) {
  return function(d) { return "Budget"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a22328771 = messageFormatterFn((function(  ) {
  return function(d) { return "Discount code"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a320265139 = messageFormatterFn((function(  ) {
  return function(d) { return "Done, " + d["0"] + " nights selected. Save changes and close the date picker."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a24682447 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1088708592 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1284429979 = messageFormatterFn((function(  ) {
  return function(d) { return "Nonstop"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1063411383 = messageFormatterFn((function(  ) {
  return function(d) { return "Child " + d["0"] + " age, " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b62230065 = messageFormatterFn((function(  ) {
  return function(d) { return "Property type"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1445891729 = messageFormatterFn((function(  ) {
  return function(d) { return "Flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346146246 = messageFormatterFn((function(  ) {
  return function(d) { return "5."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1539046231 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - 1 min drive"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a906697523 = messageFormatterFn((function(  ) {
  return function(d) { return "When you book a hotel and car together, we negotiate incredible deals and pass savings on to you. The savings on this bundle cover the cost of your car."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1031721206 = messageFormatterFn((function(  ) {
  return function(d) { return "Very good"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a750886444 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1611831440 = messageFormatterFn((function(  ) {
  return function(d) { return "We collected " + d["0"] + " reviews in total for all stations in " + d["1"] + " with an average score of " + d["2"] + " out of " + d["3"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a814834971 = messageFormatterFn((function(  ) {
  return function(d) { return "We're not sure what happened. Please try your search again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a843476063 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " from city centre"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a879410301 = messageFormatterFn((function(  ) {
  return function(d) { return "Couples like:"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a993118689 = messageFormatterFn((function(  ) {
  return function(d) { return "Babysitting or childcare (surcharge)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1061303800 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1296503458 = messageFormatterFn((function(  ) {
  return function(d) { return "24-hour front desk"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b821418091 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel name, city or airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1497225386 = messageFormatterFn((function(  ) {
  return function(d) { return "See all " + d["0"] + " properties close to " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a243324705 = messageFormatterFn((function(  ) {
  return function(d) { return "Wonderful"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a590619871 = messageFormatterFn((function(  ) {
  return function(d) { return "Business centre"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1550951874 = messageFormatterFn((function(  ) {
  return function(d) { return "Please be aware that some of these reviews may have been translated automatically into English."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1191379844 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b548391625 = messageFormatterFn((function(  ) {
  return function(d) { return "Link to the " + d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1549131718 = messageFormatterFn((function(  ) {
  return function(d) { return "Ski-in/ski-out access"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b910673538 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " area reviews"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a598557539 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2091183899 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel my booking"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a981664702 = messageFormatterFn((function(  ) {
  return function(d) { return "Free valet parking"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b368087197 = messageFormatterFn((function(  ) {
  return function(d) { return "found 1 hour ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1622997288 = messageFormatterFn((function(  ) {
  return function(d) { return "See all available properties in " + d["1"] + " starting at " + d["0"] + " per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a736583136 = messageFormatterFn((function(  ) {
  return function(d) { return "Your hotel cancellation is being processed"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a84186525 = messageFormatterFn((function(  ) {
  return function(d) { return "Concierge services"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a979484962 = messageFormatterFn((function(  ) {
  return function(d) { return "Luxury"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1951800740 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels for less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1793119993 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - Beachfront property"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1546648245 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices & availability"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b503292033 = messageFormatterFn((function(  ) {
  return function(d) { return "The price is " + d["0"] + " on average per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2014823699 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight and car packages can only be booked with one hotel stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1843420258 = messageFormatterFn((function(  ) {
  return function(d) { return "10-14 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1123788340 = messageFormatterFn((function(  ) {
  return function(d) { return "It looks like you already submitted this request. We're processing it now."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1814283095 = messageFormatterFn((function(  ) {
  return function(d) { return "Find more properties by adding these popular filters to your search"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1151566022 = messageFormatterFn((function(  ) {
  return function(d) { return "Itinerary " + "#" + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1796127591 = messageFormatterFn((function(  ) {
  return function(d) { return "Smoke-free property"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1663962274 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " average per night for 4 and more star hotels."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b354755164 = messageFormatterFn((function(  ) {
  return function(d) { return "Outdoor pool"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a230095702 = messageFormatterFn((function(  ) {
  return function(d) { return "Recently viewed hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1371252015 = messageFormatterFn((function(  ) {
  return function(d) { return "Great for golfers"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b899033893 = messageFormatterFn((function(  ) {
  return function(d) { return "Trip savings"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b144885771 = messageFormatterFn((function(  ) {
  return function(d) { return "Learn more about " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1752406366 = messageFormatterFn((function(  ) {
  return function(d) { return "Search and compare flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a251702787 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Stops"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a345548613 = messageFormatterFn((function(  ) {
  return function(d) { return "Property name"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a361555434 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you flying from?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1944251693 = messageFormatterFn((function(  ) {
  return function(d) { return "All amenities"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a788904713 = messageFormatterFn((function(  ) {
  return function(d) { return "Looking for another destination?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1481239986 = messageFormatterFn((function(  ) {
  return function(d) { return "No preference"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1070678810 = messageFormatterFn((function(  ) {
  return function(d) { return "Price per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b387314070 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2123845191 = messageFormatterFn((function(  ) {
  return function(d) { return "If you choose to cancel, we’ll send you a coupon equal to the full amount of the original purchase price. Just let us know if you want to cancel or keep your reservation."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b370992727 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1547874100 = messageFormatterFn((function(  ) {
  return function(d) { return "Save an average of " + d["0"] + "% with Package Rates"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a154347447 = messageFormatterFn((function(  ) {
  return function(d) { return "All-inclusive"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1370460854 = messageFormatterFn((function(  ) {
  return function(d) { return "Start with your first destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1905412772 = messageFormatterFn((function(  ) {
  return function(d) { return "Current location"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a735108352 = messageFormatterFn((function(  ) {
  return function(d) { return "Returning"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a692534779 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1203551049 = messageFormatterFn((function(  ) {
  return function(d) { return "On private beach"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1570111797 = messageFormatterFn((function(  ) {
  return function(d) { return "10-15 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346142402 = messageFormatterFn((function(  ) {
  return function(d) { return "1."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1765563764 = messageFormatterFn((function(  ) {
  return function(d) { return "Search event tickets"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1641018769 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " area review"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b426190824 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " avg/ night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a300585375 = messageFormatterFn((function(  ) {
  return function(d) { return "We can't find that itinerary number. Please double check the number and try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a137073970 = messageFormatterFn((function(  ) {
  return function(d) { return "(" + d["0"] + " review)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1856218098 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"] + " and " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b92183898 = messageFormatterFn((function(  ) {
  return function(d) { return "Property class (" + d["0"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a44379184 = messageFormatterFn((function(  ) {
  return function(d) { return "Property type (" + d["0"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b769128997 = messageFormatterFn((function(  ) {
  return function(d) { return "If you want to keep your credit and use it for a future flight with the same airline, you don't need to do anything."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a532309783 = messageFormatterFn((function(  ) {
  return function(d) { return "When is the best time to visit " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b130735523 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, something went wrong."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a471438163 = messageFormatterFn((function(  ) {
  return function(d) { return "1 room x 1 night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1570110836 = messageFormatterFn((function(  ) {
  return function(d) { return "6-9 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2130635666 = messageFormatterFn((function(  ) {
  return function(d) { return "We will notify you through the email you used to book your trip when it is complete with additional information on your refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1807792548 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " results loading below"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b495412970 = messageFormatterFn((function(  ) {
  return function(d) { return "found " + d["0"] + " days ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1511406911 = messageFormatterFn((function(  ) {
  return function(d) { return "Itinerary " + "#" + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a82449275 = messageFormatterFn((function(  ) {
  return function(d) { return "Expert cruise advice " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1214505077 = messageFormatterFn((function(  ) {
  return function(d) { return "If you want to keep your credit and use it for a future flight with the same airline, you don't need to do anything."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a44500275 = messageFormatterFn((function(  ) {
  return function(d) { return "We're sorry. Something went wrong on our end. Please try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a746441160 = messageFormatterFn((function(  ) {
  return function(d) { return "Pets"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2015441576 = messageFormatterFn((function(  ) {
  return function(d) { return "Reviews in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1122146442 = messageFormatterFn((function(  ) {
  return function(d) { return "Great trips, great savings"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1117686144 = messageFormatterFn((function(  ) {
  return function(d) { return "Free wired high-speed Internet"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1267269313 = messageFormatterFn((function(  ) {
  return function(d) { return "Photo by " + d["0"] + " (" + d["1"] + ") / Cropped from original"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1328499993 = messageFormatterFn((function(  ) {
  return function(d) { return "there are " + d["0"] + " results"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a375895037 = messageFormatterFn((function(  ) {
  return function(d) { return "More trip options"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1843419297 = messageFormatterFn((function(  ) {
  return function(d) { return "7-9 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1371068642 = messageFormatterFn((function(  ) {
  return function(d) { return "This form doesn't work for cancelling cruises. Please sign in to your account and cancel from within your online itinerary."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b340128023 = messageFormatterFn((function(  ) {
  return function(d) { return "We're unable to find your current location"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346144324 = messageFormatterFn((function(  ) {
  return function(d) { return "3."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b888378921 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b290271789 = messageFormatterFn((function(  ) {
  return function(d) { return "Multi-city"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a537638641 = messageFormatterFn((function(  ) {
  return function(d) { return "We don't recognize that email address. Please double check the email address and try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a345155745 = messageFormatterFn((function(  ) {
  return function(d) { return "at least"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1758039882 = messageFormatterFn((function(  ) {
  return function(d) { return "Find the best cruise deals on your favourite fleets"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a694241605 = messageFormatterFn((function(  ) {
  return function(d) { return "Babysitting or childcare (free)"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a455463868 = messageFormatterFn((function(  ) {
  return function(d) { return "3 star"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1317488944 = messageFormatterFn((function(  ) {
  return function(d) { return "Click to get hotel deals for " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b809658284 = messageFormatterFn((function(  ) {
  return function(d) { return "Find your next hotel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1219246780 = messageFormatterFn((function(  ) {
  return function(d) { return "10."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a383474044 = messageFormatterFn((function(  ) {
  return function(d) { return "1 room x " + d["0"] + " nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b108981346 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the date selector without saving changes. Or, edit the dates below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b953807159 = messageFormatterFn((function(  ) {
  return function(d) { return "from " + d["0"] + ", roundtrip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a433535565 = messageFormatterFn((function(  ) {
  return function(d) { return "Map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b947504287 = messageFormatterFn((function(  ) {
  return function(d) { return "Roundtrip non-stop flight included"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b227875012 = messageFormatterFn((function(  ) {
  return function(d) { return "Roundtrip flight included"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b769127075 = messageFormatterFn((function(  ) {
  return function(d) { return "This refund request is only for the flight listed above."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a151411588 = messageFormatterFn((function(  ) {
  return function(d) { return "Show less things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b638577468 = messageFormatterFn((function(  ) {
  return function(d) { return "Rooms and Travellers Selector, " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a380130997 = messageFormatterFn((function(  ) {
  return function(d) { return "Your package deal unlocks savings on hotels and cars."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a275248988 = messageFormatterFn((function(  ) {
  return function(d) { return "average per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346150090 = messageFormatterFn((function(  ) {
  return function(d) { return "9."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a359915569 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per day"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a758090352 = messageFormatterFn((function(  ) {
  return function(d) { return "Price details breakdown for this Hotel and Car package"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a363887022 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you coming from?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b31942779 = messageFormatterFn((function(  ) {
  return function(d) { return "Price per night shown is the average (mean) price based on a two-person, one-room, one-night stay. Average price is calculated using the lowest nightly price from the last 24 hours for each property available in the market 45 days from today."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a729701312 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodation"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1207341600 = messageFormatterFn((function(  ) {
  return function(d) { return "See all available properties near " + d["1"] + " starting at " + d["0"] + " per night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1012952542 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up date"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b925926487 = messageFormatterFn((function(  ) {
  return function(d) { return "Browse by theme"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1311054523 = messageFormatterFn((function(  ) {
  return function(d) { return "No, don’t cancel"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b776015499 = messageFormatterFn((function(  ) {
  return function(d) { return "Not sure when to go to " + d["0"] + "? Check out price trends for the year below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b782983044 = messageFormatterFn((function(  ) {
  return function(d) { return "Your car unlocks savings on hotels and activities."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1570112758 = messageFormatterFn((function(  ) {
  return function(d) { return "15+ nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a490756992 = messageFormatterFn((function(  ) {
  return function(d) { return "4 star +"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1213502832 = messageFormatterFn((function(  ) {
  return function(d) { return "Cheap"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2122058414 = messageFormatterFn((function(  ) {
  return function(d) { return "Cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2122061297 = messageFormatterFn((function(  ) {
  return function(d) { return "Flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1094110736 = messageFormatterFn((function(  ) {
  return function(d) { return "Where will you pick-up and drop-off?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b645863797 = messageFormatterFn((function(  ) {
  return function(d) { return "2 star & under"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b550462641 = messageFormatterFn((function(  ) {
  return function(d) { return "Stop " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1512403648 = messageFormatterFn((function(  ) {
  return function(d) { return "Trip Themes"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1712076135 = messageFormatterFn((function(  ) {
  return function(d) { return "Restaurant"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2047035783 = messageFormatterFn((function(  ) {
  return function(d) { return "Drivers under " + d["0"] + " or over " + d["1"] + " may need to pay an extra fee."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a96787750 = messageFormatterFn((function(  ) {
  return function(d) { return "Your airline handles all cancellations. Please contact the airline directly."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a55904990 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " average per night for 3 star hotels."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b416121267 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1288654081 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1787741291 = messageFormatterFn((function(  ) {
  return function(d) { return "Done, 1 night selected. Save changes and close the date picker."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b991911246 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a148936076 = messageFormatterFn((function(  ) {
  return function(d) { return "Your flight cancellation is being processed"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b591552699 = messageFormatterFn((function(  ) {
  return function(d) { return "Price per night (" + d["0"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b297562176 = messageFormatterFn((function(  ) {
  return function(d) { return "Driver age between " + d["0"] + " - " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1207140521 = messageFormatterFn((function(  ) {
  return function(d) { return "1 car"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1843418336 = messageFormatterFn((function(  ) {
  return function(d) { return "2-6 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b695749338 = messageFormatterFn((function(  ) {
  return function(d) { return "1 night stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1220087085 = messageFormatterFn((function(  ) {
  return function(d) { return "Rent a ride"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1517037494 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Map"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a689960442 = messageFormatterFn((function(  ) {
  return function(d) { return "When is the best time to visit " + d["0"] + "?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1474274886 = messageFormatterFn((function(  ) {
  return function(d) { return "found " + d["0"] + " hours ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b87919216 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select an airport"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a285059667 = messageFormatterFn((function(  ) {
  return function(d) { return "We’re unable to process your cancellation because it is less than 24 hours before your check-in date."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1344626089 = messageFormatterFn((function(  ) {
  return function(d) { return "Airline confirmation: " + d["0"] + " (" + d["1"] + ")"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b672124401 = messageFormatterFn((function(  ) {
  return function(d) { return "Looking for sports, concerts or theatre events? Search event tickets"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1813536186 = messageFormatterFn((function(  ) {
  return function(d) { return "Holiday homes"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b942759442 = messageFormatterFn((function(  ) {
  return function(d) { return "Your package deal unlocks savings on hotels."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b409069290 = messageFormatterFn((function(  ) {
  return function(d) { return "found " + d["0"] + " minutes ago"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2090475102 = messageFormatterFn((function(  ) {
  return function(d) { return "Payment types"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2053625260 = messageFormatterFn((function(  ) {
  return function(d) { return "Free self parking"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a621275751 = messageFormatterFn((function(  ) {
  return function(d) { return "Build a trip"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b776536881 = messageFormatterFn((function(  ) {
  return function(d) { return "<span>out of 5</span>"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a735332787 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " min walk"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1986571961 = messageFormatterFn((function(  ) {
  return function(d) { return "Find flights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b857061694 = messageFormatterFn((function(  ) {
  return function(d) { return "We will contact you when your coupon is available. You must sign in to your " + d["0"] + " account to access the coupon code. If you do not have an account with " + d["0"] + ", we will create one using " + d["1"] + ". We will create a temporary password for you and ask you to set a new password when you sign in for the first time."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1500594752 = messageFormatterFn((function(  ) {
  return function(d) { return "Departing between"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a770982586 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b222364007 = messageFormatterFn((function(  ) {
  return function(d) { return "Property class"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b535730807 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - 1 min walk"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1845373680 = messageFormatterFn((function(  ) {
  return function(d) { return "roundtrip flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b623765590 = messageFormatterFn((function(  ) {
  return function(d) { return "Laundry facilities"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1490889668 = messageFormatterFn((function(  ) {
  return function(d) { return "Compact rental car and 1-night stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346147207 = messageFormatterFn((function(  ) {
  return function(d) { return "6."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346143363 = messageFormatterFn((function(  ) {
  return function(d) { return "2."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1077417936 = messageFormatterFn((function(  ) {
  return function(d) { return "When you book a hotel and car together, we negotiate incredible deals and pass savings on to you."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1346149129 = messageFormatterFn((function(  ) {
  return function(d) { return "8."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1974327928 = messageFormatterFn((function(  ) {
  return function(d) { return "Enable geolocation services"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1899965824 = messageFormatterFn((function(  ) {
  return function(d) { return "Discover deals on board top cruise lines around the world"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1549718268 = messageFormatterFn((function(  ) {
  return function(d) { return "Free cancellation available"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1436392771 = messageFormatterFn((function(  ) {
  return function(d) { return "Your activity unlocks savings on hotels and cars."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a452555410 = messageFormatterFn((function(  ) {
  return function(d) { return "Choose your room"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1381738512 = messageFormatterFn((function(  ) {
  return function(d) { return "Itinerary " + "#" + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1731240961 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"] + " min drive"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1161686435 = messageFormatterFn((function(  ) {
  return function(d) { return "No preference"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1982322857 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination, property name, airport, train station, landmark, or address"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b847479115 = messageFormatterFn((function(  ) {
  return function(d) { return "roundtrip non-stop flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2102555531 = messageFormatterFn((function(  ) {
  return function(d) { return "Total for 2 adults"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b778077888 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more things to do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a937256513 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1181124140 = messageFormatterFn((function(  ) {
  return function(d) { return "Trip ends"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1859540704 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1029732362 = messageFormatterFn((function(  ) {
  return function(d) { return "Show less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b988102218 = messageFormatterFn((function(  ) {
  return function(d) { return "Package deals"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1886632657 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecting an option opens a search results page with the selected filter applied"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1510341217 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1365275386 = messageFormatterFn((function(  ) {
  return function(d) { return "Read reviews of " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b984199292 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers Selector, " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a940680360 = messageFormatterFn((function(  ) {
  return function(d) { return "Show " + d["0"] + " results"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1663013991 = messageFormatterFn((function(  ) {
  return function(d) { return "Children and extra beds"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1813136685 = messageFormatterFn((function(  ) {
  return function(d) { return "Things To Do"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a955550795 = messageFormatterFn((function(  ) {
  return function(d) { return "24-hour business centre"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1649938981 = messageFormatterFn((function(  ) {
  return function(d) { return "Save on packages"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1298498953 = messageFormatterFn((function(  ) {
  return function(d) { return "1 night"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a715440515 = messageFormatterFn((function(  ) {
  return function(d) { return "I have read and accept the <a href=\"" + d["0"] + "\">Package Rate Program Terms and Conditions</a> and understand that package rates can only be booked in combination with a flight, car or train booking for the same traveller and trip."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1903621259 = messageFormatterFn((function(  ) {
  return function(d) { return "Free WiFi"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1539255773 = messageFormatterFn((function(  ) {
  return function(d) { return "Find hotels for less"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b480401048 = messageFormatterFn((function(  ) {
  return function(d) { return "Price details"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2071673764 = messageFormatterFn((function(  ) {
  return function(d) { return "Family-friendly"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b896622528 = messageFormatterFn((function(  ) {
  return function(d) { return "Pets allowed"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1843417375 = messageFormatterFn((function(  ) {
  return function(d) { return "Any Duration"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1341780881 = messageFormatterFn((function(  ) {
  return function(d) { return "I don't need accommodations for this stop"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1570109875 = messageFormatterFn((function(  ) {
  return function(d) { return "Less than 6 nights"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1856219059 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " and " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b718142836 = messageFormatterFn((function(  ) {
  return function(d) { return "Enter a city name or an attraction"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1980427899 = messageFormatterFn((function(  ) {
  return function(d) { return "Conference centre"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2027494533 = messageFormatterFn((function(  ) {
  return function(d) { return "Get more information about " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1058183389 = messageFormatterFn((function(  ) {
  return function(d) { return "Cars"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1318248622 = messageFormatterFn((function(  ) {
  return function(d) { return "See fewer areas"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b688119464 = messageFormatterFn((function(  ) {
  return function(d) { return "Not sure when to go to " + d["0"] + "? Check out price trends for the year below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1752725550 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " night stay"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1807121588 = messageFormatterFn((function(  ) {
  return function(d) { return "You're all set."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b473600164 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for " + d["0"] + ", " + d["1"] + " and " + d["2"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2135042204 = messageFormatterFn((function(  ) {
  return function(d) { return "Link to the " + d["0"] + " travel guide"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b473601125 = messageFormatterFn((function(  ) {
  return function(d) { return "Known for " + d["0"] + " and " + d["1"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1788328095 = messageFormatterFn((function(  ) {
  return function(d) { return "You only selected one. Select two or more travel items to search vacation packages."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2077886984 = messageFormatterFn((function(  ) {
  return function(d) { return "Accommodations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a597122861 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " average per night for 2 and under star hotels."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1303906848 = messageFormatterFn((function(  ) {
  return function(d) { return "Great for couples"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1329273644 = messageFormatterFn((function(  ) {
  return function(d) { return "Grocery/convenience store"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b40730951 = messageFormatterFn((function(  ) {
  return function(d) { return "Indoor pool"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a51393334 = messageFormatterFn((function(  ) {
  return function(d) { return "Want to see what's around?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2086820631 = messageFormatterFn((function(  ) {
  return function(d) { return "Any"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1507376487 = messageFormatterFn((function(  ) {
  return function(d) { return "Getting your current location"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1518363526 = messageFormatterFn((function(  ) {
  return function(d) { return "Our accreditations"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b583391299 = messageFormatterFn((function(  ) {
  return function(d) { return "Flight"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a259164315 = messageFormatterFn((function(  ) {
  return function(d) { return "Bundle and save"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1645277472 = messageFormatterFn((function(  ) {
  return function(d) { return "Where are you flying to?"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a407063706 = messageFormatterFn((function(  ) {
  return function(d) { return "We will notify you through the email you used to book your trip when it is complete with additional information on your refund."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a584525569 = messageFormatterFn((function(  ) {
  return function(d) { return "Your airline handles all cancellations. Please contact the airline directly."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1283454441 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off time"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1432416540 = messageFormatterFn((function(  ) {
  return function(d) { return "Stays"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1324028808 = messageFormatterFn((function(  ) {
  return function(d) { return "Thank you for choosing " + d["0"] + " as your travel partner."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a2064802368 = messageFormatterFn((function(  ) {
  return function(d) { return "Top Hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1166800180 = messageFormatterFn((function(  ) {
  return function(d) { return "Click-to-Cancel | " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1176409747 = messageFormatterFn((function(  ) {
  return function(d) { return "Search by city or attraction"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a575324470 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " per person"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1577251935 = messageFormatterFn((function(  ) {
  return function(d) { return "Average nightly hotel price for 2 adults. </b> All prices shown are in " + d["0"] + "."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b845397433 = messageFormatterFn((function(  ) {
  return function(d) { return "Your trip starts here"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1396460828 = messageFormatterFn((function(  ) {
  return function(d) { return "Narrow your search on hotels in " + d["0"]; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1632438464 = messageFormatterFn((function(  ) {
  return function(d) { return "Not sure when to go to " + d["0"] + "? Check out price trends for the year below."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b918297985 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.a1779191031 = messageFormatterFn((function(  ) {
  return function(d) { return "We can't find that itinerary number. Please double check the number and try again."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1095964689 = messageFormatterFn((function(  ) {
  return function(d) { return "Driver between " + d["0"] + " and " + d["1"] + " years old"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1410057773 = messageFormatterFn((function(  ) {
  return function(d) { return "Ad"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b2106684965 = messageFormatterFn((function(  ) {
  return function(d) { return "Retry"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1758821580 = messageFormatterFn((function(  ) {
  return function(d) { return "About this ad"; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1896006834 = messageFormatterFn((function(  ) {
  return function(d) { return "We've run into a problem retrieving this information."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b730973600 = messageFormatterFn((function(  ) {
  return function(d) { return "We are not able to provide the information at this time."; }
})(), Globalize("en-CA").pluralGenerator({}));
Globalize.b1036417907 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a2144003021 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b2023596192 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1148917146 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b2096823251 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a725074274 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b299101235 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b2042682227 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1513187955 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a2029799712 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1479724077 = dateToPartsFormatterFn({"2":Globalize("en-CA").numberFormatter({"raw":"00"}),"4":Globalize("en-CA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b66107470 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"W","thu":"T","fri":"F","sat":"S"}}}});
Globalize.a1106215309 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Sunday","mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday"}}}});
Globalize.b147030131 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.a258127987 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a2147277760 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"}),"2":Globalize("en-CA").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1619657473 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"MMM d","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"Mar.","4":"Apr.","5":"May","6":"Jun.","7":"Jul.","8":"Aug.","9":"Sep.","10":"Oct.","11":"Nov.","12":"Dec."}}}});
Globalize.b1125471219 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"MMMM d, y","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.b1976028813 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.b1975343620 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"MMM d, y","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"Mar.","4":"Apr.","5":"May","6":"Jun.","7":"Jul.","8":"Aug.","9":"Sep.","10":"Oct.","11":"Nov.","12":"Dec."}}}});
Globalize.a2086712001 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, MMM d","timeSeparator":":","days":{"E":{"4":{"sun":"Sunday","mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday"}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"Mar.","4":"Apr.","5":"May","6":"Jun.","7":"Jul.","8":"Aug.","9":"Sep.","10":"Oct.","11":"Nov.","12":"Dec."}}}});
Globalize.b1356975200 = dateToPartsFormatterFn({"1":Globalize("en-CA").numberFormatter({"raw":"0"})}, {"pattern":"E, MMM d","timeSeparator":":","days":{"E":{"1":{"sun":"Sun.","mon":"Mon.","tue":"Tue.","wed":"Wed.","thu":"Thu.","fri":"Fri.","sat":"Sat."}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"Mar.","4":"Apr.","5":"May","6":"Jun.","7":"Jul.","8":"Aug.","9":"Sep.","10":"Oct.","11":"Nov.","12":"Dec."}}}});
Globalize.b657704156 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1772250524 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b208678985 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1331132943 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1718109500 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1754975815 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a79612516 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1663968476 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1134474204 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b450250377 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1858437828 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b217280837 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a270054756 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b983190684 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a841411580 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"d"}));
Globalize.a1755870679 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a2047516042 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a2024720470 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1597315062 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1596629869 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1468981450 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b978261449 = dateFormatterFn(Globalize("en-CA").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a956357587 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b158188781 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b998059994 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b2120513952 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b104047757 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1750610472 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1693674259 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b49906733 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a479587539 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1239631386 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b822467725 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1588853932 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^W/],["thu",/^T/],["fri",/^F/],["sat",/^S/]]});
Globalize.b641514157 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^Wednesday/],["thu",/^Thursday/],["sat",/^Saturday/],["tue",/^Tuesday/],["sun",/^Sunday/],["mon",/^Monday/],["fri",/^Friday/]]});
Globalize.b1894759597 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.b716375443 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1911473670 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b948458757 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM d","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Jan\./],["2",/^Feb\./],["3",/^Mar\./],["4",/^Apr\./],["6",/^Jun\./],["7",/^Jul\./],["8",/^Aug\./],["9",/^Sep\./],["10",/^Oct\./],["11",/^Nov\./],["12",/^Dec\./],["5",/^May/]]});
Globalize.a521026951 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM d, y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.a16746681 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.a17431874 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM d, y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Jan\./],["2",/^Feb\./],["3",/^Mar\./],["4",/^Apr\./],["6",/^Jun\./],["7",/^Jul\./],["8",/^Aug\./],["9",/^Sep\./],["10",/^Oct\./],["11",/^Nov\./],["12",/^Dec\./],["5",/^May/]]});
Globalize.b471478853 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE, MMM d","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^Wednesday/],["thu",/^Thursday/],["sat",/^Saturday/],["tue",/^Tuesday/],["sun",/^Sunday/],["mon",/^Monday/],["fri",/^Friday/]],"gregorian/months/format/abbreviated":[["1",/^Jan\./],["2",/^Feb\./],["3",/^Mar\./],["4",/^Apr\./],["6",/^Jun\./],["7",/^Jul\./],["8",/^Aug\./],["9",/^Sep\./],["10",/^Oct\./],["11",/^Nov\./],["12",/^Dec\./],["5",/^May/]]});
Globalize.a635800294 = dateParserFn(Globalize("en-CA").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"E, MMM d","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^Sun\./],["mon",/^Mon\./],["tue",/^Tue\./],["wed",/^Wed\./],["thu",/^Thu\./],["fri",/^Fri\./],["sat",/^Sat\./]],"gregorian/months/format/abbreviated":[["1",/^Jan\./],["2",/^Feb\./],["3",/^Mar\./],["4",/^Apr\./],["6",/^Jun\./],["7",/^Jul\./],["8",/^Aug\./],["9",/^Sep\./],["10",/^Oct\./],["11",/^Nov\./],["12",/^Dec\./],["5",/^May/]]});
module.exports = Globalize;
